<template>
    <div id="map-content" v-bind:style="{height: myHeight}">
        <span style="display: none">
            {{filterQuery}}
        </span>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            filterEmpty: false,
            houseMgtDataEmpty: false,
            houseMgtDataError: false,
            isLoading: true,
            map: null,
            zoom: 10,
            center: {lat:25.0882456, lng:121.4905524},
            countyMarkers: [],
            districtMarkers: [],
            houseMarkers: [],
            markerClusterer: null,
            clusterState: true,
            clusterHouseId: [],
            selectCounty: null,
            selectDistrict: null,
            mcOptions: {
                gridSize: 50,
                styles: [
                   {
                        width: 36,
                        height: 36,
                        className: 'custom-clustericon-1'
                    },
                    {
                        width: 36,
                        height: 36,
                        className: 'custom-clustericon-2',

                    },
                    {
                        width: 36,
                        height: 36,
                        className: 'custom-clustericon-3',
                    }
                ],
                clusterClass: 'custom-clustericon',
                maxZoom: 15
            },        
            countyLocation: [
                {
                    county: '台北市',
                    count: null,
                    lat: 25.0375417,
                    lng: 121.562244,
                    districts:[
                        {
                            district: '中正區',
                            lng: 121.5198839,
                            lat: 25.03240487,
                            count: null
                        },
                        {
                            district: '大同區',
                            lng: 121.5130417,
                            lat: 25.06342433,
                            count: null
                        },
                        {
                            district: '中山區',
                            lng: 121.5381597,
                            lat: 25.06969917,
                            count: null
                        },
                        {
                            district: '松山區',
                            lng: 121.5575876,
                            lat: 25.05999101,
                            count: null
                        },
                        {
                            district: '大安區',
                            lng: 121.5434446,
                            lat: 25.02677012,
                            count: null
                        },
                        {
                            district: '萬華區',
                            lng: 121.4979858,
                            lat: 25.0285899,
                            count: null,       
                        },
                        {
                            district: '信義區',
                            lng: 121.5716697,
                            lat: 25.03062083,
                            count: null
                        },
                        {
                            district: '文山區',
                            lng: 121.557719,
                            lat: 24.9880061,
                            count: null
                        },
                        {
                            district: '士林區',
                            lng: 121.5508473,
                            lat: 25.12546704,
                            count: null
                        },
                        {
                            district: '北投區',
                            lng: 121.5177992,
                            lat: 25.1480682,
                            count: null
                        },
                        {
                            district: '內湖區',
                            lng: 121.5923828,
                            lat: 25.08370623,
                            count: null
                        },
                        {
                            district: '南港區',
                            lng: 121.6097573,
                            lat: 25.03600934,
                            count: null
                        },
                    ]
                },
                {
                    county: '新北市',
                    count: null,
                    lat: 25.0123025,
                    lng: 121.4632612,
                    districts: [
                        {
                            district: '萬里區',
                            lng: 121.6439307,
                            lat: 25.17572457,
                            count: null
                        },
                        {
                            district: '金山區',
                            lng: 121.6052639,
                            lat: 25.21714594,
                            count: null
                        },
                        {
                            district: '板橋區',
                            lng: 121.4579675,
                            lat: 25.01186453,
                            count: null
                        },
                        {
                            district: '汐止區',
                            lng: 121.6546992,
                            lat: 25.07331322,
                            count: null
                        },
                        {
                            district: '深坑區',
                            lng: 121.6200624,
                            lat: 24.99767506,
                            count: null
                        },
                        {
                            district: '石碇區',
                            lng: 121.6472277,
                            lat: 24.94714107,
                            count: null
                        },
                        {
                            district: '瑞芳區',
                            lng: 121.8232018,
                            lat: 25.0981293,
                            count: null,       
                        },
                        {
                            district: '平溪區',
                            lng: 121.7578817,
                            lat: 25.02607068,
                            count: null
                        },
                        {
                            district: '雙溪區',
                            lng: 121.8329822,
                            lat: 24.99698394,
                            count: null
                        },
                        {
                            district: '貢寮區',
                            lng: 121.9182466,
                            lat: 25.02485641,
                            count: null
                        },
                        {
                            district: '新店區',
                            lng: 121.5316565,
                            lat: 24.93039008,
                            count: null
                        },
                        {
                            district: '坪林區',
                            lng: 121.724223,
                            lat: 24.91097073,
                            count: null
                        },
                        {
                            district: '烏來區',
                            lng: 121.5414806,
                            lat: 24.78824295,
                            count: null
                        },
                        {
                            district: '永和區',
                            lng: 121.516745,
                            lat: 25.00810199,
                            count: null
                        },
                        {
                            district: '中和區',
                            lng: 121.4936744,
                            lat: 24.99088039,
                            count: null
                        },
                        {
                            district: '土城區',
                            lng: 121.445737,
                            lat: 24.96425102,
                            count: null
                        },
                        {
                            district: '三峽區',
                            lng: 121.4163094,
                            lat: 24.88209766,
                            count: null
                        },
                        {
                            district: '樹林區',
                            lng: 121.401034,
                            lat: 24.97970609,
                            count: null
                        },
                        {
                            district: '鶯歌區',
                            lng: 121.3466269,
                            lat: 24.9566258,        
                            count: null
                        },
                        {
                            district: '三重區',
                            lng: 121.4870977,
                            lat: 25.06281651,
                            count: null
                        },
                        {
                            district: '新莊區',
                            lng: 121.4367535,
                            lat: 25.0358303,        
                            count: null
                        },
                        {
                            district: '泰山區',
                            lng: 121.4162785,
                            lat: 25.05549774,
                            count: null
                        },
                        {
                            district: '林口區',
                            lng: 121.3527235,
                            lat: 25.1000868,        
                            count: null
                        },
                        {
                            district: '蘆洲區',
                            lng: 121.4712461,
                            lat: 25.08927173,
                            count: null
                        },
                        {
                            district: '五股區',
                            lng: 121.4332139,
                            lat: 25.09614746,
                            count: null
                        },
                        {
                            district: '八里區',
                            lng: 121.4138359,
                            lat: 25.13812763,
                            count: null
                        },
                        {
                            district: '淡水區',
                            lng: 121.463904,
                            lat: 25.18907636,
                            count: null
                        },
                        {
                            district: '三芝區',
                            lng: 121.515558,
                            lat: 25.23159891,
                            count: null
                        },
                        {
                            district: '石門區',
                            lng: 121.5692761,
                            lat: 25.26518079,
                            count: null
                        },
                    ]
                },
                {
                    county: '基隆市',
                    count: null,
                    lat: 25.10898,
                    lng: 121.7081,
                    districts: [
                        {
                            district: '仁愛區',
                            lng: 121.7434205,
                            lat: 25.11945421,
                            count: null
                        },
                        {
                            district: '信義區',
                            lng: 121.772646,
                            lat: 25.12576579,
                            count: null
                        },
                        {
                            district: '中正區',
                            lng: 121.7783549,
                            lat: 25.14365754,
                            count: null
                        },
                        {
                            district: '中山區',
                            lng: 121.7308913,
                            lat: 25.14986365,
                            count: null
                        },
                        {
                            district: '安樂區',
                            lng: 121.7078325,
                            lat: 25.14139521,
                            count: null
                        },
                        {
                            district: '暖暖區',
                            lng: 121.7447344,
                            lat: 25.08097003,
                            count: null
                        },
                        {
                            district: '七堵區',
                            lng: 121.683628,
                            lat: 25.10962028,
                            count: null
                        },
                    ]
                },
                {
                    county: '桃園市',
                    count: null,
                    lat: 24.93759,
                    lng: 121.2168,
                    districts: [
                        {
                            district: '中壢區',
                            lng: 121.2147243,
                            lat: 24.97993803,
                            count: null
                        },
                        {
                            district: '平鎮區',
                            lng: 121.2140051,
                            lat: 24.92117923,
                            count: null
                        },
                        {
                            district: '龍潭區',
                            lng: 121.2117877,
                            lat: 24.85064954,
                            count: null
                        },
                        {
                            district: '楊梅區',
                            lng: 121.1291697,
                            lat: 24.91820989,
                            count: null
                        },
                        {
                            district: '新屋區',
                            lng: 121.067758,
                            lat: 24.97280352,
                            count: null
                        },
                        {
                            district: '觀音區',
                            lng: 121.1155021,
                            lat: 25.02671611,
                            count: null
                        },
                        {
                            district: '桃園區',
                            lng: 121.2996612,
                            lat: 25.00040024,
                            count: null
                        },
                        {
                            district: '龜山區',
                            lng: 121.3569265,
                            lat: 25.02417472,
                            count: null
                        },
                        {
                            district: '八德區',
                            lng: 121.2913102,
                            lat: 24.94968903,
                            count: null
                        },
                        {
                            district: '大溪區',
                            lng: 121.296342,
                            lat: 24.86797026,
                            count: null
                        },
                        {
                            district: '復興區',
                            lng: 121.3754588,
                            lat: 24.72949884,
                            count: null
                        },
                        {
                            district: '大園區',
                            lng: 121.21177,
                            lat: 25.06384709,
                            count: null
                        },
                        {
                            district: '蘆竹區',
                            lng: 121.2831266,
                            lat: 25.06073337,
                            count: null
                        },
                    ]
                },
                {
                    county: '宜蘭縣',
                    count: null,
                    lat: 24.69295,
                    lng: 121.7195,
                    districts:[
                        {
                            district: '宜蘭市',
                            lng: 121.7569358,
                            lat: 24.75021184,
                            count: null
                        },
                        {
                            district: '頭城鎮',
                            lng: 121.845797,
                            lat: 24.90075882,
                            count: null
                        },
                        {
                            district: '礁溪鄉',
                            lng: 121.7346606,
                            lat: 24.81144192,
                            count: null
                        },
                        {
                            district: '壯圍鄉',
                            lng: 121.8017622,
                            lat: 24.75183042,
                            count: null
                        },
                        {
                            district: '員山鄉',
                            lng: 121.6612282,
                            lat: 24.74199237,
                            count: null
                        },
                        {
                            district: '羅東鎮',
                            lng: 121.7701782,
                            lat: 24.67884824,
                            count: null
                        },
                        {
                            district: '三星鄉',
                            lng: 121.6642714,
                            lat: 24.66771972,
                            count: null
                        },
                        {
                            district: '大同鄉',
                            lng: 121.5040369,
                            lat: 24.55152082,
                            count: null
                        },
                        {
                            district: '五結鄉',
                            lng: 121.8058342,
                            lat: 24.68887343,
                            count: null
                        },
                        {
                            district: '冬山鄉',
                            lng: 121.760255,
                            lat: 24.64214986,
                            count: null
                        },
                        {
                            district: '蘇澳鎮',
                            lng: 121.8346892,
                            lat: 24.55467058,
                            count: null
                        },
                        {
                            district: '南澳鄉',
                            lng: 121.6560593,
                            lat: 24.44864058,
                            count: null
                        },
                        {
                            district: '釣魚臺列嶼',
                            lng: 123.475482,
                            lat: 25.746396,
                            count: null
                        },
                    ]
                },
                {
                    county: '高雄市',
                    count: null,
                    lat: 23.01087,
                    lng: 120.666,
                    districts: [
                        {
                            district: '新興區',
                            lng: 120.3067337,
                            lat: 22.62992906,
                            count: null
                        },
                        {
                            district: '前金區',
                            lng: 120.2944217,
                            lat: 22.6269905,        
                            count: null
                        },
                        {
                            district: '苓雅區',
                            lng: 120.3209103,
                            lat: 22.62359448,
                            count: null
                        },
                        {
                            district: '鹽埕區',
                            lng: 120.2842331,
                            lat: 22.62424585,
                            count: null
                        },
                        {
                            district: '鼓山區',
                            lng: 120.274163,
                            lat: 22.65019525,
                            count: null
                        },
                        {
                            district: '旗津區',
                            lng: 120.2891539,
                            lat: 22.58565583,
                            count: null
                        },
                        {
                            district: '前鎮區',
                            lng: 120.3146749,
                            lat: 22.59269724,
                            count: null
                        },
                        {
                            district: '三民區',
                            lng: 120.3179187,
                            lat: 22.64989883,
                            count: null
                        },
                        {
                            district: '楠梓區',
                            lng: 120.300758,
                            lat: 22.72109961,
                            count: null
                        },
                        {
                            district: '小港區',
                            lng: 120.3592605,
                            lat: 22.55140207,
                            count: null
                        },
                        {
                            district: '左營區',
                            lng: 120.2951588,
                            lat: 22.68395699,
                            count: null
                        },
                        {
                            district: '仁武區',
                            lng: 120.3605265,
                            lat: 22.70120782,
                            count: null
                        },
                        {
                            district: '大社區',
                            lng: 120.3707994,
                            lat: 22.73983479,
                            count: null
                        },
                        {
                            district: '岡山區',
                            lng: 120.2978906,
                            lat: 22.80505886,
                            count: null
                        },
                        {
                            district: '路竹區',
                            lng: 120.2659871,
                            lat: 22.85724171,
                            count: null
                        },
                        {
                            district: '阿蓮區',
                            lng: 120.3210967,
                            lat: 22.87022883,
                            count: null
                        },
                        {
                            district: '田寮區',
                            lng: 120.3959842,
                            lat: 22.86394307,
                            count: null
                        },
                        {
                            district: '燕巢區',
                            lng: 120.370799,
                            lat: 22.78769626,
                            count: null
                        },
                        {
                            district: '橋頭區',
                            lng: 120.3006534,
                            lat: 22.75252398,
                            count: null
                        },
                        {
                            district: '梓官區',
                            lng: 120.2593989,
                            lat: 22.748209,
                            count: null
                        },
                        {
                            district: '彌陀區',
                            lng: 120.2394571,
                            lat: 22.77944528,
                            count: null
                        },
                        {
                            district: '永安區',
                            lng: 120.228051,
                            lat: 22.82224585,
                            count: null
                        },
                        {
                            district: '湖內區',
                            lng: 120.2259375,
                            lat: 22.89324952,
                            count: null
                        },
                        {
                            district: '鳳山區',
                            lng: 120.3554359,
                            lat: 22.61379251,
                            count: null
                        },
                        {
                            district: '大寮區',
                            lng: 120.4111468,
                            lat: 22.59283576,
                            count: null
                        },
                        {
                            district: '林園區',
                            lng: 120.399052,
                            lat: 22.50813743,
                            count: null
                        },
                        {
                            district: '鳥松區',
                            lng: 120.3727783,
                            lat: 22.66249302,
                            count: null
                        },
                        {
                            district: '大樹區',
                            lng: 120.425407,
                            lat: 22.71100364,
                            count: null
                        },
                        {
                            district: '旗山區',
                            lng: 120.4754554,
                            lat: 22.86497033,
                            count: null
                        },
                        {
                            district: '美濃區',
                            lng: 120.5634635,
                            lat: 22.90005529,
                            count: null
                        },
                        {
                            district: '六龜區',
                            lng: 120.6585635,
                            lat: 23.01195426,
                            count: null
                        },
                        {
                            district: '內門區',
                            lng: 120.4719272,
                            lat: 22.95668817,
                            count: null
                        },
                        {
                            district: '杉林區',
                            lng: 120.5621971,
                            lat: 22.99694681,
                            count: null
                        },
                        {
                            district: '甲仙區',
                            lng: 120.6232895,
                            lat: 23.11654995,
                            count: null
                        },
                        {
                            district: '桃源區',
                            lng: 120.8523383,
                            lat: 23.2249459,        
                            count: null
                        },
                        {
                            district: '那瑪夏區',
                            lng: 120.741944,
                            lat: 23.275008,       
                            count: null
                        },
                        {
                            district: '茂林區',
                            lng: 120.752384,
                            lat: 22.91993256,
                            count: null
                        },
                        {
                            district: '茄萣區',
                            lng: 120.1980519,
                            lat: 22.88241399,
                            count: null
                        },
                    ]
                },
                {
                    county: '台中市',
                    count: null,
                    lat: 24.23321,
                    lng: 120.9417,
                    districts:[
                        {
                            district: '中區',            
                            lng: 120.680598,           
                            lat: 24.14168566,
                            count: null
                        },
                        {
                            district: '東區',           
                            lng: 120.6970865,           
                            lat: 24.13733209,
                            count: null
                        },
                        {
                            district: '南區',            
                            lng: 120.6646178,           
                            lat: 24.12114107,
                            count: null
                        },
                        {
                            district: '西區',
                            lng: 120.6647579,
                            lat: 24.14391082,
                            count: null
                        },
                        {
                            district: '北區',
                            lng: 120.6809521,
                            lat: 24.15863985,
                            count: null
                        },
                        {
                            district: '北屯區',
                            lng: 120.7362319,
                            lat: 24.18400298,
                            count: null
                        },
                        {
                            district: '西屯區',
                            lng: 120.6270131,
                            lat: 24.18308895,
                            count: null
                        },
                        {
                            district: '南屯區',
                            lng: 120.6177379,
                            lat: 24.14165524,
                            count: null
                        },
                        {
                            district: '太平區',
                            lng: 120.7734217,
                            lat: 24.11477375,
                            count: null
                        },
                        {
                            district: '大里區',
                            lng: 120.6926261,
                            lat: 24.09575742,
                            count: null
                        },
                        {
                            district: '霧峰區',
                            lng: 120.7201989,
                            lat: 24.04332785,
                            count: null
                        },
                        {
                            district: '烏日區',
                            lng: 120.6293305,
                            lat: 24.0839271,
                            count: null
                        },
                        {
                            district: '豐原區',
                            lng: 120.7375715,
                            lat: 24.24990298,
                            count: null
                        },
                        {
                            district: '后里區',
                            lng: 120.7146127,
                            lat: 24.30962483,
                            count: null
                        },
                        {
                            district: '石岡區',
                            lng: 120.7903822,
                            lat: 24.26493299,
                            count: null
                        },
                        {
                            district: '東勢區',
                            lng: 120.8401401,
                            lat: 24.24952637,
                            count: null
                        },
                        {
                            district: '和平區',
                            lng: 121.140185,
                            lat: 24.27620277,
                            count: null
                        },
                        {
                            district: '新社區',
                            lng: 120.8313228,
                            lat: 24.17769289,
                            count: null
                        },
                        {
                            district: '潭子區',
                            lng: 120.710997,
                            lat: 24.21171121,
                            count: null
                        },
                        {
                            district: '大雅區',
                            lng: 120.6411818,
                            lat: 24.22704181,
                            count: null
                        },
                        {
                            district: '神岡區',
                            lng: 120.6733321,
                            lat: 24.26568008,
                            count: null
                        },
                        {
                            district: '大肚區',
                            lng: 120.5543243,
                            lat: 24.14467504,
                            count: null
                        },
                        {
                            district: '沙鹿區',
                            lng: 120.5838628,
                            lat: 24.23425212,
                            count: null
                        },
                        {
                            district: '龍井區',
                            lng: 120.5283728,
                            lat: 24.20062892,
                            count: null
                        },
                        {
                            district: '梧棲區',
                            lng: 120.5301259,
                            lat: 24.24552431,
                            count: null
                        },
                        {
                            district: '清水區',
                            lng: 120.5809094,
                            lat: 24.29205743,
                            count: null
                        },
                        {
                            district: '大甲區',
                            lng: 120.6357901,
                            lat: 24.37827161,
                            count: null
                        },
                        {
                            district: '外埔區',
                            lng: 120.6650639,
                            lat: 24.33551071,
                            count: null
                        },
                        {
                            district: '大安區',
                            lng: 120.5914407,
                            lat: 24.36509555,
                            count: null
                        },
                    ]
                },
                {
                    county: '台南市',
                    count: null,
                    lat: 23.1417,
                    lng: 120.2513,
                    districts: [
                        {
                            district: '中西區',
                            lng: 120.192874,
                            lat: 22.99594458,
                            count: null
                        },
                        {
                            district: '東區',            
                            lng: 120.2281858,
                            lat: 22.98178202,
                            count: null
                        },
                        {
                            district: '南區',
                            lng: 120.1903743,
                            lat: 22.95561863,
                            count: null
                        },
                        {
                            district: '北區',
                            lng: 120.2068735,
                            lat: 23.01012179,
                            count: null
                        },
                        {
                            district: '安平區',
                            lng: 120.1649949,
                            lat: 22.99008437,
                            count: null
                        },
                        {
                            district: '安南區',
                            lng: 120.1526189,
                            lat: 23.04869681,
                            count: null
                        },
                        {
                            district: '永康區',
                            lng: 120.2542795,
                            lat: 23.02729532,
                            count: null
                        },
                        {
                            district: '歸仁區',
                            lng: 120.2930627,
                            lat: 22.94679469,
                            count: null
                        },
                        {
                            district: '新化區',
                            lng: 120.3357964,
                            lat: 23.03394545,
                            count: null
                        },
                        {
                            district: '左鎮區',
                            lng: 120.4123917,
                            lat: 23.02604611,
                            count: null
                        },
                        {
                            district: '玉井區',
                            lng: 120.4609622,
                            lat: 23.11480926,
                            count: null
                        },
                        {
                            district: '楠西區',
                            lng: 120.5170304,
                            lat: 23.17885854,
                            count: null
                        },
                        {
                            district: '南化區',
                            lng: 120.5441223,
                            lat: 23.1151111,
                            count: null
                        },
                        {
                            district: '仁德區',
                            lng: 120.2418788,
                            lat: 22.94130931,
                            count: null
                        },
                        {
                            district: '關廟區',
                            lng: 120.3342821,
                            lat: 22.95577909,
                            count: null
                        },
                        {
                            district: '龍崎區',
                            lng: 120.3869373,
                            lat: 22.95482276,
                            count: null
                        },
                        {
                            district: '官田區',
                            lng: 120.3479918,
                            lat: 23.19098548,
                            count: null
                        },
                        {
                            district: '麻豆區',
                            lng: 120.241308,
                            lat: 23.18248033,
                            count: null
                        },
                        {
                            district: '佳里區',
                            lng: 120.178593,
                            lat: 23.1669941,
                            count: null
                        },
                        {
                            district: '西港區',
                            lng: 120.2002309,
                            lat: 23.12491893,
                            count: null
                        },
                        {
                            district: '七股區',
                            lng: 120.1005854,
                            lat: 23.12326578,
                            count: null
                        },
                        {
                            district: '將軍區',
                            lng: 120.1276958,
                            lat: 23.20834413,
                            count: null
                        },
                        {
                            district: '學甲區',
                            lng: 120.1841865,
                            lat: 23.25219805,
                            count: null
                        },
                        {
                            district: '北門區',
                            lng: 120.1262357,
                            lat: 23.2777708,
                            count: null
                        },
                        {
                            district: '新營區',
                            lng: 120.2954067,
                            lat: 23.30152488,
                            count: null
                        },
                        {
                            district: '後壁區',
                            lng: 120.3485081,
                            lat: 23.36201478,
                            count: null
                        },
                        {
                            district: '白河區',
                            lng: 120.4578565,
                            lat: 23.35132068,
                            count: null
                        },
                        {
                            district: '東山區',
                            lng: 120.4441211,
                            lat: 23.2783187,
                            count: null
                        },
                        {
                            district: '六甲區',
                            lng: 120.3800259,
                            lat: 23.2272672,
                            count: null
                        },
                        {
                            district: '下營區',
                            lng: 120.26484,
                            lat: 23.23103978,
                            count: null
                        },
                        {
                            district: '柳營區',
                            lng: 120.3549205,
                            lat: 23.26887001,
                            count: null
                        },
                        {
                            district: '鹽水區',
                            lng: 120.2482977,
                            lat: 23.29798622,
                            count: null
                        },
                        {
                            district: '善化區',
                            lng: 120.2988274,
                            lat: 23.14031072,
                            count: null
                        },
                        {
                            district: '大內區',
                            lng: 120.3988147,
                            lat: 23.14482152,
                            count: null
                        },
                        {
                            district: '山上區',
                            lng: 120.370977,
                            lat: 23.09689329,
                            count: null
                        },
                        {
                            district: '新市區',
                            lng: 120.2923941,
                            lat: 23.08319496,
                            count: null
                        },
                        {
                            district: '安定區',
                            lng: 120.2296235,
                            lat: 23.09974927,
                            count: null
                        },
                    ]
                },
                {
                    county: '彰化縣',
                    count: null,
                    lat: 23.99297,
                    lng: 120.4818,
                    districts: [
                        {
                            district: '彰化市',
                            lng: 120.5694208,
                            lat: 24.07532909,
                            count: null
                        },
                        {
                            district: '芬園鄉',
                            lng: 120.6294414,
                            lat: 24.00628794,
                            count: null
                        },
                        {
                            district: '花壇鄉',
                            lng: 120.5597655,
                            lat: 24.03006875,
                            count: null
                        },
                        {
                            district: '秀水鄉',
                            lng: 120.5041184,
                            lat: 24.03249405,
                            count: null
                        },
                        {
                            district: '鹿港鎮',
                            lng: 120.4385491,
                            lat: 24.08286685,
                            count: null
                        },
                        {
                            district: '福興鄉',
                            lng: 120.4310511,
                            lat: 24.03021674,
                            count: null
                        },
                        {
                            district: '線西鄉',
                            lng: 120.452157,
                            lat: 24.13158127,
                            count: null
                        },
                        {
                            district: '和美鎮',
                            lng: 120.5112045,
                            lat: 24.11379535,
                            count: null
                        },
                        {
                            district: '伸港鄉',
                            lng: 120.486449,
                            lat: 24.16367107,
                            count: null
                        },
                        {
                            district: '員林市',
                            lng: 120.593073,
                            lat: 23.95650448,
                            count: null
                        },
                        {
                            district: '社頭鄉',
                            lng: 120.6021661,
                            lat: 23.90536413,
                            count: null
                        },
                        {
                            district: '永靖鄉',
                            lng: 120.5416032,
                            lat: 23.92139507,
                            count: null
                        },
                        {
                            district: '埔心鄉',
                            lng: 120.5342802,
                            lat: 23.95277521,
                            count: null
                        },
                        {
                            district: '溪湖鎮',
                            lng: 120.4831739,
                            lat: 23.95171456,
                            count: null
                        },
                        {
                            district: '大村鄉',
                            lng: 120.5586866,
                            lat: 23.99209206,
                            count: null
                        },
                        {
                            district: '埔鹽鄉',
                            lng: 120.4594626,
                            lat: 23.99204417,
                            count: null
                        },
                        {
                            district: '田中鎮',
                            lng: 120.5903471,
                            lat: 23.85723872,
                            count: null
                        },
                        {
                            district: '北斗鎮',
                            lng: 120.5331566,
                            lat: 23.867574,
                            count: null
                        },
                        {
                            district: '田尾鄉',
                            lng: 120.5223244,
                            lat: 23.90056065,
                            count: null
                        },
                        {
                            district: '埤頭鄉',
                            lng: 120.4675642,
                            lat: 23.88234118,
                            count: null
                        },
                        {
                            district: '溪州鄉',
                            lng: 120.5224904,
                            lat: 23.82725185,
                            count: null
                        },
                        {
                            district: '竹塘鄉',
                            lng: 120.4136645,
                            lat: 23.8505872,
                            count: null
                        },
                        {
                            district: '二林鎮',
                            lng: 120.404225,
                            lat: 23.91621405,
                            count: null
                        },
                        {
                            district: '大城鄉',
                            lng: 120.3113284,
                            lat: 23.85069276,
                            count: null
                        },
                        {
                            district: '芳苑鄉',
                            lng: 120.3539226,
                            lat: 23.9537906,
                            count: null
                        },
                        {
                            district: '二水鄉',
                            lng: 120.628589,
                            lat: 23.8092402,
                            count: null
                        },
                    ]
                },
                {
                    county: '屏東縣',
                    count: null,
                    lat: 22.54951,
                    lng: 120.62,
                    districts: [
                        {
                            district: '屏東市',
                            lng: 120.4799948,
                            lat: 22.6647375,
                            count: null
                        },
                        {
                            district: '三地門鄉',
                            lng: 120.6865219,
                            lat: 22.79786847,
                            count: null
                        },
                        {
                            district: '霧臺鄉',
                            lng: 120.8008099,
                            lat: 22.75990478,
                            count: null
                        },
                        {
                            district: '瑪家鄉',
                            lng: 120.6799239,
                            lat: 22.67107764,
                            count: null
                        },
                        {
                            district: '九如鄉',
                            lng: 120.4845044,
                            lat: 22.7316677,
                            count: null
                        },
                        {
                            district: '里港鄉',
                            lng: 120.5061276,
                            lat: 22.79854831,
                            count: null
                        },
                        {
                            district: '高樹鄉',
                            lng: 120.6017678,
                            lat: 22.80992022,
                            count: null
                        },
                        {
                            district: '鹽埔鄉',
                            lng: 120.5693941,
                            lat: 22.74253636,
                            count: null
                        },
                        {
                            district: '長治鄉',
                            lng: 120.555979,
                            lat: 22.69454952,
                            count: null
                        },
                        {
                            district: '麟洛鄉',
                            lng: 120.5299693,
                            lat: 22.64876367,
                            count: null
                        },
                        {
                            district: '竹田鄉',
                            lng: 120.5266379,
                            lat: 22.58855636,
                            count: null
                        },
                        {
                            district: '內埔鄉',
                            lng: 120.5888222,
                            lat: 22.65116933,
                            count: null
                        },
                        {
                            district: '萬丹鄉',
                            lng: 120.4766188,
                            lat: 22.58849547,
                            count: null
                        },
                        {
                            district: '潮州鎮',
                            lng: 120.5568063,
                            lat: 22.53642947,
                            count: null
                        },
                        {
                            district: '泰武鄉',
                            lng: 120.6917929,
                            lat: 22.60408477,
                            count: null
                        },
                        {
                            district: '來義鄉',
                            lng: 120.6857232,
                            lat: 22.50157206,
                            count: null
                        },
                        {
                            district: '萬巒鄉',
                            lng: 120.601817,
                            lat: 22.58233459,
                            count: null
                        },
                        {
                            district: '崁頂鄉',
                            lng: 120.5006598,
                            lat: 22.51528151,
                            count: null
                        },
                        {
                            district: '新埤鄉',
                            lng: 120.5846257,
                            lat: 22.48676279,
                            count: null
                        },
                        {
                            district: '南州鄉',
                            lng: 120.5180561,
                            lat: 22.47980704,
                            count: null
                        },
                        {
                            district: '林邊鄉',
                            lng: 120.5125095,
                            lat: 22.44142101,
                            count: null
                        },
                        {
                            district: '東港鎮',
                            lng: 120.4751333,
                            lat: 22.46265635,
                            count: null
                        },
                        {
                            district: '琉球鄉',
                            lng: 120.3710466,
                            lat: 22.34000278,
                            count: null
                        },
                        {
                            district: '佳冬鄉',
                            lng: 120.5476124,
                            lat: 22.42980624,
                            count: null
                        },
                        {
                            district: '新園鄉',
                            lng: 120.4501429,
                            lat: 22.5171903,
                            count: null
                        },
                        {
                            district: '枋寮鄉',
                            lng: 120.5975845,
                            lat: 22.40334199,
                            count: null
                        },
                        {
                            district: '枋山鄉',
                            lng: 120.6567673,
                            lat: 22.27086962,
                            count: null
                        },
                        {
                            district: '春日鄉',
                            lng: 120.6975799,
                            lat: 22.40399754,
                            count: null
                        },
                        {
                            district: '獅子鄉',
                            lng: 120.7356454,
                            lat: 22.26084921,
                            count: null
                        },
                        {
                            district: '車城鄉',
                            lng: 120.7432633,
                            lat: 22.07915617,
                            count: null
                        },
                        {
                            district: '牡丹鄉',
                            lng: 120.8173609,
                            lat: 22.15552859,
                            count: null
                        },
                        {
                            district: '恆春鎮',
                            lng: 120.7632537,
                            lat: 21.98531645,
                            count: null
                        },
                        {
                            district: '滿州鄉',
                            lng: 120.8435675,
                            lat: 22.04930015,
                            count: null
                        },
                    ]
                },
                {
                    county: '雲林縣',
                    count: null,
                    lat: 23.75585,
                    lng: 120.3897,
                    districts: [
                        {
                            district: '斗南鎮',
                            lng: 120.4826356,
                            lat: 23.67066393,
                            count: null
                        },
                        {
                            district: '大埤鄉',
                            lng: 120.4255592,
                            lat: 23.6455971,
                            count: null
                        },
                        {
                            district: '虎尾鎮',
                            lng: 120.4293061,
                            lat: 23.71661545,
                            count: null
                        },
                        {
                            district: '土庫鎮',
                            lng: 120.3647252,
                            lat: 23.69110665,
                            count: null
                        },
                        {
                            district: '褒忠鄉',
                            lng: 120.3116122,
                            lat: 23.71613204,
                            count: null
                        },
                        {
                            district: '東勢鄉',
                            lng: 120.2564173,
                            lat: 23.69612324,
                            count: null
                        },
                        {
                            district: '臺西鄉',
                            lng: 120.2054952,
                            lat: 23.71600815,
                            count: null
                        },
                        {
                            district: '崙背鄉',
                            lng: 120.3339769,
                            lat: 23.77849791,
                            count: null
                        },
                        {
                            district: '麥寮鄉',
                            lng: 120.243533,
                            lat: 23.78817056,
                            count: null
                        },
                        {
                            district: '斗六市',
                            lng: 120.5600044,
                            lat: 23.70651883,
                            count: null
                        },
                        {
                            district: '林內鄉',
                            lng: 120.6155018,
                            lat: 23.7557209,
                            count: null
                        },
                        {
                            district: '古坑鄉',
                            lng: 120.6117351,
                            lat: 23.62545469,
                            count: null
                        },
                        {
                            district: '莿桐鄉',
                            lng: 120.5290419,
                            lat: 23.76973894,
                            count: null
                        },
                        {
                            district: '西螺鎮',
                            lng: 120.4580795,
                            lat: 23.77942109,
                            count: null
                        },
                        {
                            district: '二崙鄉',
                            lng: 120.3964598,
                            lat: 23.7925521,
                            count: null
                        },
                        {
                            district: '北港鎮',
                            lng: 120.2940164,
                            lat: 23.59219528,
                            count: null
                        },
                        {
                            district: '水林鄉',
                            lng: 120.2352734,
                            lat: 23.56162849,
                            count: null
                        },
                        {
                            district: '口湖鄉',
                            lng: 120.1413711,
                            lat: 23.55365395,
                            count: null
                        },
                        {
                            district: '四湖鄉',
                            lng: 120.2064699,
                            lat: 23.64206875,
                            count: null
                        },
                        {
                            district: '元長鄉',
                            lng: 120.3279617,
                            lat: 23.64243095,
                            count: null
                        },
                    ]
                },
                {
                    county: '苗栗縣',
                    count: null,
                    lat: 24.48927,
                    lng: 120.9417,
                    districts: [
                        {
                            district: '竹南鎮',
                            lng: 120.8777316,
                            lat: 24.69862459,
                            count: null
                        },
                        {
                            district: '頭份市',
                            lng: 120.9189437,
                            lat: 24.67628243,
                            count: null
                        },
                        {
                            district: '三灣鄉',
                            lng: 120.9525745,
                            lat: 24.63599405,
                            count: null
                        },
                        {
                            district: '南庄鄉',
                            lng: 121.017471,
                            lat: 24.56608432,
                            count: null
                        },
                        {
                            district: '獅潭鄉',
                            lng: 120.9206688,
                            lat: 24.51978614,
                            count: null
                        },
                        {
                            district: '後龍鎮',
                            lng: 120.781205,
                            lat: 24.6156265,
                            count: null
                        },
                        {
                            district: '通霄鎮',
                            lng: 120.7146378,
                            lat: 24.4850464,
                            count: null
                        },
                        {
                            district: '苑裡鎮',
                            lng: 120.6882195,
                            lat: 24.4110232,
                            count: null
                        },
                        {
                            district: '苗栗市',
                            lng: 120.8112299,
                            lat: 24.56382141,
                            count: null
                        },
                        {
                            district: '造橋鄉',
                            lng: 120.8695663,
                            lat: 24.62481314,
                            count: null
                        },
                        {
                            district: '頭屋鄉',
                            lng: 120.8826631,
                            lat: 24.57345497,
                            count: null
                        },
                        {
                            district: '公館鄉',
                            lng: 120.8505904,
                            lat: 24.50249686,
                            count: null
                        },
                        {
                            district: '大湖鄉',
                            lng: 120.8631192,
                            lat: 24.39359641,
                            count: null
                        },
                        {
                            district: '泰安鄉',
                            lng: 121.0681571,
                            lat: 24.41925819,
                            count: null
                        },
                        {
                            district: '銅鑼鄉',
                            lng: 120.7992043,
                            lat: 24.45591832,
                            count: null
                        },
                        {
                            district: '三義鄉',
                            lng: 120.7701929,
                            lat: 24.38081659,
                            count: null
                        },
                        {
                            district: '西湖鄉',
                            lng: 120.7614144,
                            lat: 24.54153218,
                            count: null
                        },
                        {
                            district: '卓蘭鎮',
                            lng: 120.8561966,
                            lat: 24.32510167,
                            count: null
                        },
                    ]
                },
                {
                    county: '嘉義縣',
                    count: null,
                    lat: 23.45889,
                    lng: 120.574,
                    districts: [
                        {
                            district: '番路鄉',
                            lng: 120.6075335,
                            lat: 23.42765669,
                            count: null
                        },
                        {
                            district: '梅山鄉',
                            lng: 120.6387459,
                            lat: 23.55535465,
                            count: null
                        },
                        {
                            district: '竹崎鄉',
                            lng: 120.5965771,
                            lat: 23.50376527,
                            count: null
                        },
                        {
                            district: '阿里山鄉',
                            lng: 120.7596173,
                            lat: 23.44077619,
                            count: null
                        },
                        {
                            district: '中埔鄉',
                            lng: 120.5365312,
                            lat: 23.40408998,
                            count: null
                        },
                        {
                            district: '大埔鄉',
                            lng: 120.5896466,
                            lat: 23.28848426,
                            count: null
                        },
                        {
                            district: '水上鄉',
                            lng: 120.4147357,
                            lat: 23.42911287,
                            count: null
                        },
                        {
                            district: '鹿草鄉',
                            lng: 120.3045468,
                            lat: 23.40811736,
                            count: null
                        },
                        {
                            district: '太保市',
                            lng: 120.3440009,
                            lat: 23.4729191,
                            count: null
                        },
                        {
                            district: '朴子市',
                            lng: 120.2538977,
                            lat: 23.44610605,
                            count: null
                        },
                        {
                            district: '東石鄉',
                            lng: 120.1738682,
                            lat: 23.46866059,
                            count: null
                        },
                        {
                            district: '六腳鄉',
                            lng: 120.2714728,
                            lat: 23.51020984,
                            count: null
                        },
                        {
                            district: '新港鄉',
                            lng: 120.3482873,
                            lat: 23.54581295,
                            count: null
                        },
                        {
                            district: '民雄鄉',
                            lng: 120.4442798,
                            lat: 23.54255347,
                            count: null
                        },
                        {
                            district: '大林鎮',
                            lng: 120.4807865,
                            lat: 23.59890827,
                            count: null
                        },
                        {
                            district: '溪口鄉',
                            lng: 120.4010282,
                            lat: 23.59353089,
                            count: null
                        },
                        {
                            district: '義竹鄉',
                            lng: 120.2239433,
                            lat: 23.34575872,
                            count: null
                        },
                        {
                            district: '布袋鎮',
                            lng: 120.1777498,
                            lat: 23.37494276,
                            count: null
                        },
                    ]
                },
                {
                    county: '新竹縣',
                    count: null,
                    lat: 24.70328,
                    lng: 121.1252,
                    districts: [
                        {
                            district: '竹北市',
                            lng: 120.9948704,
                            lat: 24.83816209,
                            count: null
                        },
                        {
                            district: '湖口鄉',
                            lng: 121.0517242,
                            lat: 24.88566341,
                            count: null
                        },
                        {
                            district: '新豐鄉',
                            lng: 120.9956033,
                            lat: 24.90731298,
                            count: null
                        },
                        {
                            district: '新埔鎮',
                            lng: 121.0939886,
                            lat: 24.84133959,
                            count: null
                        },
                        {
                            district: '關西鎮',
                            lng: 121.1866221,
                            lat: 24.78514681,
                            count: null
                        },
                        {
                            district: '芎林鄉',
                            lng: 121.1046394,
                            lat: 24.7657116,
                            count: null
                        },
                    ]
                },
                {
                    county: '新竹市',
                    count: null,
                    lat: 24.80395,
                    lng: 120.9647,
                    districts:[
                        {
                            district: '北區',
                            lng: 120.9491233,
                            lat: 24.82269542,
                            count: null
                        },
                        {
                            district: '東區',
                            lng: 120.9927505,
                            lat: 24.79028174,
                            count: null
                        },
                        {
                            district: '香山區',
                            lng: 120.9236727,
                            lat: 24.77104342,
                            count: null
                        },
                    ]
                },
                {
                    county: '南投縣',
                    count: null,
                    lat: 23.83876,
                    lng: 120.9876,
                    districts: [
                        {
                            district: '南投市',
                            lng: 120.6787658,
                            lat: 23.92173537,
                            count: null
                        },
                        {
                            district: '中寮鄉',
                            lng: 120.7859159,
                            lat: 23.90589214,
                            count: null
                        },
                        {
                            district: '草屯鎮',
                            lng: 120.7326182,
                            lat: 23.98321081,
                            count: null
                        },
                        {
                            district: '國姓鄉',
                            lng: 120.8676052,
                            lat: 24.03135413,
                            count: null
                        },
                        {
                            district: '埔里鎮',
                            lng: 120.9625259,
                            lat: 23.97892591,
                            count: null
                        },
                        {
                            district: '仁愛鄉',
                            lng: 121.1443879,
                            lat: 24.02886513,
                            count: null
                        },
                        {
                            district: '名間鄉',
                            lng: 120.6774402,
                            lat: 23.8510771,
                            count: null
                        },
                        {
                            district: '集集鎮',
                            lng: 120.7854192,
                            lat: 23.83701687,
                            count: null
                        },
                        {
                            district: '水里鄉',
                            lng: 120.8622721,
                            lat: 23.79612907,
                            count: null
                        },
                        {
                            district: '魚池鄉',
                            lng: 120.9256736,
                            lat: 23.87601213,
                            count: null
                        },
                        {
                            district: '信義鄉',
                            lng: 121.0212867,
                            lat: 23.6554647,
                            count: null
                        },
                        {
                            district: '竹山鎮',
                            lng: 120.7100797,
                            lat: 23.69805518,
                            count: null
                        },
                        {
                            district: '鹿谷鄉',
                            lng: 120.7815065,
                            lat: 23.73776029,
                            count: null
                        },
                    ]
                },
                {
                    county: '嘉義市',
                    count: null,
                    lat: 23.47545,
                    lng: 120.4473,
                    districts: [
                        {
                            district: '西區',
                            lng: 120.4248724,
                            lat: 23.47915529,
                            count: null
                        },
                        {
                            district: '東區',
                            lng: 120.4706244,
                            lat: 23.48170334,
                            count: null
                        },
                    ]
                },
                {
                    county: '台東縣',
                    count: null,
                    lat: 22.98461,
                    lng: 120.9876,
                    districts: [
                        {
                            district: '臺東市',
                            lng: 121.1103647,
                            lat: 22.75165721,
                            count: null
                        },
                        {
                            district: '綠島鄉',
                            lng: 121.4901951,
                            lat: 22.66017537,
                            count: null
                        },
                        {
                            district: '蘭嶼鄉',
                            lng: 121.5508328,
                            lat: 22.04616835,
                            count: null
                        },
                        {
                            district: '延平鄉',
                            lng: 120.9831902,
                            lat: 22.90343174,
                            count: null
                        },
                        {
                            district: '卑南鄉',
                            lng: 121.0015521,
                            lat: 22.76494453,
                            count: null
                        },
                        {
                            district: '鹿野鄉',
                            lng: 121.1560376,
                            lat: 22.95125666,
                            count: null
                        },
                        {
                            district: '關山鎮',
                            lng: 121.1766197,
                            lat: 23.03780684,
                            count: null
                        },
                        {
                            district: '海端鄉',
                            lng: 121.0175672,
                            lat: 23.11478528,
                            count: null
                        },
                        {
                            district: '池上鄉',
                            lng: 121.2184501,
                            lat: 23.09248714,
                            count: null
                        },
                        {
                            district: '東河鄉',
                            lng: 121.2517917,
                            lat: 22.98006921,
                            count: null
                        },
                        {
                            district: '成功鎮',
                            lng: 121.3537983,
                            lat: 23.12663716,
                            count: null
                        },
                        {
                            district: '長濱鄉',
                            lng: 121.4261725,
                            lat: 23.33476899,
                            count: null
                        },
                        {
                            district: '太麻里鄉',
                            lng: 120.9797643,
                            lat: 22.59098082,
                            count: null
                        },
                        {
                            district: '金峰鄉',
                            lng: 120.8570384,
                            lat: 22.58161687,
                            count: null
                        },
                        {
                            district: '大武鄉',
                            lng: 120.8991703,
                            lat: 22.38359522,
                            count: null
                        },
                        {
                            district: '達仁鄉',
                            lng: 120.8355239,
                            lat: 22.38430718,
                            count: null
                        },
                    ]
                },
                {
                    county: '花蓮縣',
                    count: null,
                    lat: 23.7569,
                    lng: 121.3542,
                    districts: [
                        {
                            district: '花蓮市',
                            lng: 121.6071463,
                            lat: 23.99700271,
                            count: null
                        },
                        {
                            district: '新城鄉',
                            lng: 121.6137969,
                            lat: 24.05579952,
                            count: null
                        },
                        {
                            district: '秀林鄉',
                            lng: 121.4807194,
                            lat: 24.12374414,
                            count: null
                        },
                        {
                            district: '吉安鄉',
                            lng: 121.5646738,
                            lat: 23.95546585,
                            count: null
                        },
                        {
                            district: '壽豐鄉',
                            lng: 121.5341569,
                            lat: 23.84459714,
                            count: null
                        },
                        {
                            district: '鳳林鎮',
                            lng: 121.4698848,
                            lat: 23.74324462,
                            count: null
                        },
                        {
                            district: '光復鄉',
                            lng: 121.4351231,
                            lat: 23.64658742,
                            count: null
                        },
                        {
                            district: '豐濱鄉',
                            lng: 121.4942331,
                            lat: 23.58519428,
                            count: null
                        },
                        {
                            district: '瑞穗鄉',
                            lng: 121.4073472,
                            lat: 23.5156124,
                            count: null
                        },
                        {
                            district: '萬榮鄉',
                            lng: 121.3189531,
                            lat: 23.72772629,
                            count: null
                        },
                        {
                            district: '玉里鎮',
                            lng: 121.3604476,
                            lat: 23.37143588,
                            count: null
                        },
                        {
                            district: '卓溪鄉',
                            lng: 121.1804222,
                            lat: 23.39062875,
                            count: null
                        },
                        {
                            district: '富里鄉',
                            lng: 121.2980494,
                            lat: 23.19672092,
                            count: null
                        },
                    ]
                },
                {
                    county: '金門縣',
                    count: null,
                    lat: 24.43679,
                    lng: 118.3186,
                    districts: [
                        {
                            district: '金沙鎮',
                            lng: 118.40841,
                            lat: 24.45865,
                            count: null
                        },
                        {
                            district: '金湖鎮',
                            lng: 118.40373,
                            lat: 24.41496,
                            count: null
                        },
                        {
                            district: '金寧鄉',
                            lng: 118.31705,
                            lat: 24.42482,
                            count: null
                        },
                        {
                            district: '金城鎮',
                            lng: 118.30128,
                            lat: 24.38402,
                            count: null
                        },
                        {
                            district: '烈嶼鄉',
                            lng: 118.22789,
                            lat: 24.40166,
                            count: null
                        },
                        {
                            district: '烏坵鄉',
                            lng: 119.452738,
                            lat: 24.992338,
                            count: null
                        },
                    ]
                },
                {
                    county: '澎湖縣',
                    count: null,
                    lat: 23.56548,
                    lng: 119.6151,
                    districts: [
                        {
                            district: '馬公市',
                            lng: 119.59234,
                            lat: 23.55534,
                            count: null
                        },
                        {
                            district: '西嶼鄉',
                            lng: 119.50783,
                            lat: 23.59975,
                            count: null
                        },
                        {
                            district: '望安鄉',
                            lng: 119.50406,
                            lat: 23.36904,
                            count: null
                        },
                        {
                            district: '七美鄉',
                            lng: 119.43393,
                            lat: 23.20108,
                            count: null
                        },
                        {
                            district: '白沙鄉',
                            lng: 119.59251,
                            lat: 23.64178,
                            count: null
                        },
                        {
                            district: '湖西鄉',
                            lng: 119.64462,
                            lat: 23.57364,
                            count: null
                        },
                    ]
                },
                {
                    county: '連江縣',
                    count: null,
                    lat: 26.19737,
                    lng: 119.5397,
                    districts: [
                        {
                            district: '南竿鄉',
                            lng: 119.931128,
                            lat: 26.154321,
                            count: null
                        },
                        {
                            district: '北竿鄉',
                            lng: 119.994251,
                            lat: 26.225637,
                            count: null
                        },
                        {
                            district: '莒光鄉',
                            lng: 119.938877,
                            lat: 25.97298,
                            count: null
                        },
                        {
                            district: '東引鄉',
                            lng: 120.4903,
                            lat: 26.366101,
                            count: null
                        },
                    ]
                }
            ],
            myHeight: (window.innerHeight - 84) + 'px',
        }
    },
    mounted () {
        console.log('mounted')
        let _self = this
        setTimeout(function (){
            _self.getCountyLocation
            _self.getDistrictLocation
            _self.initMap()
            _self.setCountyMarkers()
        }, 1000)
        
    },
    updated () {
        console.log('update')
        this.setLocationDefault()
        this.deleteCountyMarkers()
        this.deleteDistrictMarkers()
        this.getCountyLocation
        this.getDistrictLocation
        this.zoom = 10
        this.setCountyMarkers()
        this.setCountyPosition()
        // this.setCenter(this.houseMarkerCenter)
            this.initMap()

        if(this.filterQuery.district){
            this.selectDistrict = this.filterQuery.district
            this.zoom = 14
            this.map.setZoom( 14 )
            this.setHouseMarkers()
            this.initMap()
        }else if(this.filterQuery.county){
            this.selectCounty = this.filterQuery.county
            this.zoom = 12
            this.map.setZoom( 12 )
            this.setDistrictMarkers()
            // this.initMap()
        }else{
            this.setCountyMarkers()
            this.setDistrictMarkers()
            this.initMap()
        }

    },
    watch: {
        zoom: function (val) {
            if( val <= 10){
                this.deleteCountyMarkers()
                this.deleteDistrictMarkers()
                this.deleteHouseMarkers()
                this.setCountyMarkers()
                // if( this.clusterState == false){
                    // this.deleteCluster()
                    // this.clusterState = true
                // }
            }else if( val >=11 && val <= 13){
                this.deleteCountyMarkers()
                // this.deleteDistrictMarkers()
                this.deleteHouseMarkers()
                this.setDistrictMarkers()
                // if( this.clusterState == false){
                    // this.deleteCluster()
                    // this.clusterState = true
                // }
            }else if( val >= 14){
                this.deleteCountyMarkers()
                this.deleteDistrictMarkers()
                this.deleteHouseMarkers()
                this.setHouseMarkers()
                // this.deleteCluster()
                // this.clusterState = false
            }
        },
        // 該集合所包含的所有房源ID
        clusterHouseId: function (val) {
            this.$store.commit('houseManagement/set_cluster_id', val)
        },
        houseMarkerCenter: function (val) {
            console.log(val)
            this.setCenter(val.lat, val.lng)
            this.zoom = 15
            this.map.setZoom( 15 )
        }
    },
    methods: {
        initMap: function () {
            this.map = new google.maps.Map(document.getElementById("map-content"), {
                center: this.center,
                zoom: this.zoom,
                maxZoom: 20,
                minZoom: 3,
                streetViewControl: false,
                mapTypeControl: false,
                styles: [
                    {
                        "stylers": [
                        {
                            "saturation": -55
                        },
                        {
                            "lightness": 30
                        },
                        {
                            "visibility": "simplified"
                        }
                        ]
                    },
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "labels",
                        "stylers": [
                        {
                            "visibility": "off"
                        }
                        ]
                    },
                    {
                        "featureType": "administrative.neighborhood",
                        "stylers": [
                        {
                            "visibility": "simplified"
                        }
                        ]
                    },
                    {
                        "featureType": "administrative.neighborhood",
                        "elementType": "geometry",
                        "stylers": [
                        {
                            "visibility": "off"
                        }
                        ]
                    },
                    {
                        "featureType": "administrative.neighborhood",
                        "elementType": "labels.text",
                        "stylers": [
                        {
                            "visibility": "simplified"
                        }
                        ]
                    },
                    {
                        "featureType": "landscape.man_made",
                        "stylers": [
                        {
                            "visibility": "off"
                        }
                        ]
                    },
                    {
                        "featureType": "landscape.natural.terrain",
                        "stylers": [
                        {
                            "visibility": "off"
                        }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "stylers": [
                        {
                            "visibility": "off"
                        }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "labels.text",
                        "stylers": [
                        {
                            "visibility": "off"
                        }
                        ]
                    },
                    {
                        "featureType": "poi.business",
                        "stylers": [
                        {
                            "saturation": -40
                        },
                        {
                            "lightness": 65
                        },
                        {
                            "visibility": "off"
                        }
                        ]
                    },
                    {
                        "featureType": "poi.government",
                        "stylers": [
                        {
                            "visibility": "off"
                        }
                        ]
                    },
                    {
                        "featureType": "poi.medical",
                        "stylers": [
                        {
                            "visibility": "off"
                        }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "stylers": [
                        {
                            "visibility": "simplified"
                        }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "labels.text",
                        "stylers": [
                        {
                            "visibility": "off"
                        }
                        ]
                    },
                    {
                        "featureType": "poi.place_of_worship",
                        "stylers": [
                        {
                            "visibility": "simplified"
                        }
                        ]
                    },
                    {
                        "featureType": "poi.school",
                        "stylers": [
                        {
                            "visibility": "simplified"
                        }
                        ]
                    },
                    {
                        "featureType": "poi.sports_complex",
                        "stylers": [
                        {
                            "visibility": "off"
                        }
                        ]
                    },
                    {
                        "featureType": "road",
                        "stylers": [
                        {
                            "visibility": "simplified"
                        }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "stylers": [
                        {
                            "visibility": "simplified"
                        }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels",
                        "stylers": [
                        {
                            "visibility": "off"
                        }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "stylers": [
                        {
                            "visibility": "off"
                        }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels",
                        "stylers": [
                        {
                            "visibility": "off"
                        }
                        ]
                    },
                    {
                        "featureType": "road.highway.controlled_access",
                        "stylers": [
                        {
                            "visibility": "off"
                        }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "stylers": [
                        {
                            "visibility": "off"
                        }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "labels",
                        "stylers": [
                        {
                            "visibility": "off"
                        }
                        ]
                    },
                    {
                        "featureType": "transit.line",
                        "stylers": [
                        {
                            "saturation": -50
                        },
                        {
                            "lightness": 20
                        }
                        ]
                    }
                ]
            });
            var _self = this
            this.map.addListener('zoom_changed', function() {
                _self.zoom = _self.map.getZoom()
                _self.deleteCluster()
            });
            
        },
        setMarkerCluster: function () {
            this.markerClusterer = new MarkerClusterer(this.map, this.houseMarkers, {
                maxZoom: 20,
                gridSize: 50,
                styles: this.mcOptions.styles,
                clusterClass: 'custom-clustericon',
                zoomOnClick: false
            });
            this.markerClusterer.setCalculator(function(markers, numStyles) {
                var index = 0
                var title = ''
                // console.log(markers)
                markers.map( (marker) => {
                    // console.log(marker.title)
                    title += marker.cid+'_'
                })
                
                return {
                    text: markers.length,
                    index: index,
                    title: title
                };
            });
            // 點擊cluster將該底下集合的houseCid存成陣列
            let _self = this
            google.maps.event.addListener(_self.markerClusterer, 'click', function(evt) {           
                _self.clusterHouseId = []
                evt.markers_.map( (marker) => {
                    // console.log(marker.cid)
                    _self.clusterHouseId.push(marker.cid)
                })
                
            }); 
        },
        setCenter: function (lat, lng) {
            // set center
            this.map.panTo({ lat: lat, lng: lng });
        },
        setCountyMarkers: function () {
            // this.mapLayer = 'county'
            this.getCountyLocation.forEach((location, i) => {
                if( location.count != null){
                    const marker = new RichMarker({
                    // 設定為該餐廳的座標
                        position: new google.maps.LatLng(location.lat, location.lng),
                        map: this.map,
                        content: '<div id="cluster" ><span>'+location.county+'</span><span>'+location.count+' 間</span></div>',
                        shadow: 0
                    });
                    //算出該縣市所擁有區域中心點
                    let position = this.getCountyCenter(location.districts),
                        diff = this.getCountyDiff(location.districts)
                    location.pos = position
                    location.diff = diff
                    // 綁定點擊事件監聽
                    marker.addListener("click", () => {
                        this.selectCounty = location.county
                        this.$store.commit('houseManagement/set_filter_query_county', this.selectCounty)

                        this.setDistrictMarkers()
                        this.setCenter(position.lat, position.lng)
                        if( diff.lng > 0.4 || diff.lat > 0.4 ){
                            // console.log('1')
                            this.map.setZoom( this.zoom+1 ) 
                        }else if( diff.lng < 0.1 || diff.lat < 0.1 ){
                            // console.log('3')
                            this.map.setZoom( this.zoom+3 ) 
                        }else{
                            // console.log('2')
                            this.map.setZoom( this.zoom+2 ) 
                        }
                    });
                    // // 存成陣列設定Cluster
                    this.countyMarkers.push(marker)
                }
            });
        },
        setDistrictMarkers: function () {
            // this.mapLayer = 'district'
            this.countyLocation.forEach((locations, i) => {
                if( this.selectCounty == locations.county ){
                    //算出該縣市所擁有區域中心點
                    let position = this.getCountyCenter(locations.districts)
                    this.setCenter(position.lat, position.lng)
                     
                    // console.log(locations)
                    locations.districts.forEach((location, i) => {
                    if( location.count ){
                        const marker = new RichMarker({
                        // 設定為該餐廳的座標
                            position: new google.maps.LatLng(location.lat, location.lng),
                            map: this.map,
                            content: '<div id="cluster" class="district" data-district="'+location.district+'"><span>'+location.district+'</span><span>'+location.count+' 間</span></div>',
                            shadow: 0
                        });
                        
                        // // 綁定點擊事件監聽
                        marker.addListener("click", () => {
                            this.selectDistrict = location.district
                            this.$store.commit('houseManagement/set_filter_query_district', this.selectDistrict)
                            this.setHouseMarkers()

                            this.setCenter(location.lat, location.lng)
                            this.map.setZoom( this.zoom+1 )
                        });
                        // // 存成陣列設定Cluster
                        this.districtMarkers.push(marker)
                    }
                });
            }
            });
        },
        setHouseMarkers: function (district) {
            // this.mapLayer = 'house'
            this.houseMgtList.forEach((location, i) => {
                if(this.selectDistrict == location.district){
                    console.log(location)
                    const marker = new RichMarker({
                        position: new google.maps.LatLng(location.lat,  location.lng),
                        map: this.map,
                        content: '<div class="cluster-item"></div>',
                        shadow: 0,
                        cid: location.cid
                    });
                    
                    // 建立訊息視窗
                    const infowindow = new google.maps.InfoWindow({
                        content: '<div id="content"><p id="firstHeading" class="firstHeading">'+this.translateEmpty(location.empty)+' : $'+location.rentPrice+'</p></div>',
                        maxWidth: 200
                    });
                    // 綁定點擊事件監聽
                    marker.addListener("click", () => {
                        this.setCenter(location.lat, location.lng)
                        // 如果目前有開啟中的訊息視窗，先將其關閉 
                        if (this.infowindow) this.infowindow.close();
                        // 顯示被點擊地標的訊息視窗
                        infowindow.open(this.map, marker);
                        // 存入目前開啟的訊息視窗
                        this.infowindow = infowindow;
                        this.clusterHouseId = [marker.cid]
                    });
                    // 存成陣列設定Cluster
                    this.houseMarkers.push(marker)
                }
                
            });
            
            this.setMarkerCluster()
        },
        deleteCountyMarkers: function () {
            this.countyMarkers.forEach(function(e) {
                e.setMap(null);
            });
            this.countyMarkers = [];
        },
        deleteDistrictMarkers: function () {
            this.districtMarkers.forEach(function(e) {
                e.setMap(null);
            });
            this.districtMarkers = [];
        },
        deleteHouseMarkers: function () {
            this.houseMarkers.forEach(function(e) {
                e.setMap(null);
            });
            this.houseMarkers = [];
        },
        deleteCluster: function () {
            console.log('rmovec')
            console.log(this.markerClusterer)
            if(this.markerClusterer){
                var i = 0, l = this.houseMarkers.length;
                for (i; i<l; i++) {
                    this.houseMarkers[i].setMap(null)
                }
                this.houseMarkers = [];

                this.markerClusterer.clearMarkers();
            }
            
        },
        getCountyCenter: function (districts) {
            let latArr = [],
                lngArr = []
            // console.log(districts)
            districts.forEach( (position, index) => {
                if( position.count != null && position.count != undefined){
                    latArr.push(position.lat)
                    lngArr.push(position.lng)
                }
            })
            
            let latMin = latArr.sort()[0]
            let latMax = latArr.sort()[latArr.length-1]
            let lngMin = lngArr.sort()[0]
            let lngMax = lngArr.sort()[lngArr.length-1]
            
            let position = {}

            position.lng = (lngMin + lngMax) / 2
            position.lat = (latMin + latMax) / 2
            return position
        },
        getCountyDiff: function (districts) {
            let latArr = [],
                lngArr = []

            districts.forEach( (position, index) => {
                if( position.count != null && position.count != undefined){
                    latArr.push(position.lat)
                    lngArr.push(position.lng)
                }
            })
            
            let latMin = latArr.sort()[0]
            let latMax = latArr.sort()[latArr.length-1]
            let lngMin = lngArr.sort()[0]
            let lngMax = lngArr.sort()[lngArr.length-1]
            
            let position = {}


            position.lng = lngMax - lngMin
            position.lat = latMax - latMin

            return position
        },
        setCountyPosition: function () {
            if(this.filterQuery.county){
                this.countyLocation.map( (county) => {
                    if(county.county == this.filterQuery.county){
                        this.center.lat = county.pos.lat
                        this.center.lng = county.pos.lng
                    }
                })
            }
        },
        setLocationDefault: function () {
            let countyLocationDefault= [
                {
                    county: '台北市',
                    count: null,
                    lat: 25.0375417,
                    lng: 121.562244,
                    districts:[
                        {
                            district: '中正區',
                            lng: 121.5198839,
                            lat: 25.03240487,
                            count: null
                        },
                        {
                            district: '大同區',
                            lng: 121.5130417,
                            lat: 25.06342433,
                            count: null
                        },
                        {
                            district: '中山區',
                            lng: 121.5381597,
                            lat: 25.06969917,
                            count: null
                        },
                        {
                            district: '松山區',
                            lng: 121.5575876,
                            lat: 25.05999101,
                            count: null
                        },
                        {
                            district: '大安區',
                            lng: 121.5434446,
                            lat: 25.02677012,
                            count: null
                        },
                        {
                            district: '萬華區',
                            lng: 121.4979858,
                            lat: 25.0285899,
                            count: null,       
                        },
                        {
                            district: '信義區',
                            lng: 121.5716697,
                            lat: 25.03062083,
                            count: null
                        },
                        {
                            district: '文山區',
                            lng: 121.557719,
                            lat: 24.9880061,
                            count: null
                        },
                        {
                            district: '士林區',
                            lng: 121.5508473,
                            lat: 25.12546704,
                            count: null
                        },
                        {
                            district: '北投區',
                            lng: 121.5177992,
                            lat: 25.1480682,
                            count: null
                        },
                        {
                            district: '內湖區',
                            lng: 121.5923828,
                            lat: 25.08370623,
                            count: null
                        },
                        {
                            district: '南港區',
                            lng: 121.6097573,
                            lat: 25.03600934,
                            count: null
                        },
                    ]
                },
                {
                    county: '新北市',
                    count: null,
                    lat: 25.0123025,
                    lng: 121.4632612,
                    districts: [
                        {
                            district: '萬里區',
                            lng: 121.6439307,
                            lat: 25.17572457,
                            count: null
                        },
                        {
                            district: '金山區',
                            lng: 121.6052639,
                            lat: 25.21714594,
                            count: null
                        },
                        {
                            district: '板橋區',
                            lng: 121.4579675,
                            lat: 25.01186453,
                            count: null
                        },
                        {
                            district: '汐止區',
                            lng: 121.6546992,
                            lat: 25.07331322,
                            count: null
                        },
                        {
                            district: '深坑區',
                            lng: 121.6200624,
                            lat: 24.99767506,
                            count: null
                        },
                        {
                            district: '石碇區',
                            lng: 121.6472277,
                            lat: 24.94714107,
                            count: null
                        },
                        {
                            district: '瑞芳區',
                            lng: 121.8232018,
                            lat: 25.0981293,
                            count: null,       
                        },
                        {
                            district: '平溪區',
                            lng: 121.7578817,
                            lat: 25.02607068,
                            count: null
                        },
                        {
                            district: '雙溪區',
                            lng: 121.8329822,
                            lat: 24.99698394,
                            count: null
                        },
                        {
                            district: '貢寮區',
                            lng: 121.9182466,
                            lat: 25.02485641,
                            count: null
                        },
                        {
                            district: '新店區',
                            lng: 121.5316565,
                            lat: 24.93039008,
                            count: null
                        },
                        {
                            district: '坪林區',
                            lng: 121.724223,
                            lat: 24.91097073,
                            count: null
                        },
                        {
                            district: '烏來區',
                            lng: 121.5414806,
                            lat: 24.78824295,
                            count: null
                        },
                        {
                            district: '永和區',
                            lng: 121.516745,
                            lat: 25.00810199,
                            count: null
                        },
                        {
                            district: '中和區',
                            lng: 121.4936744,
                            lat: 24.99088039,
                            count: null
                        },
                        {
                            district: '土城區',
                            lng: 121.445737,
                            lat: 24.96425102,
                            count: null
                        },
                        {
                            district: '三峽區',
                            lng: 121.4163094,
                            lat: 24.88209766,
                            count: null
                        },
                        {
                            district: '樹林區',
                            lng: 121.401034,
                            lat: 24.97970609,
                            count: null
                        },
                        {
                            district: '鶯歌區',
                            lng: 121.3466269,
                            lat: 24.9566258,        
                            count: null
                        },
                        {
                            district: '三重區',
                            lng: 121.4870977,
                            lat: 25.06281651,
                            count: null
                        },
                        {
                            district: '新莊區',
                            lng: 121.4367535,
                            lat: 25.0358303,        
                            count: null
                        },
                        {
                            district: '泰山區',
                            lng: 121.4162785,
                            lat: 25.05549774,
                            count: null
                        },
                        {
                            district: '林口區',
                            lng: 121.3527235,
                            lat: 25.1000868,        
                            count: null
                        },
                        {
                            district: '蘆洲區',
                            lng: 121.4712461,
                            lat: 25.08927173,
                            count: null
                        },
                        {
                            district: '五股區',
                            lng: 121.4332139,
                            lat: 25.09614746,
                            count: null
                        },
                        {
                            district: '八里區',
                            lng: 121.4138359,
                            lat: 25.13812763,
                            count: null
                        },
                        {
                            district: '淡水區',
                            lng: 121.463904,
                            lat: 25.18907636,
                            count: null
                        },
                        {
                            district: '三芝區',
                            lng: 121.515558,
                            lat: 25.23159891,
                            count: null
                        },
                        {
                            district: '石門區',
                            lng: 121.5692761,
                            lat: 25.26518079,
                            count: null
                        },
                    ]
                },
                {
                    county: '基隆市',
                    count: null,
                    lat: 25.10898,
                    lng: 121.7081,
                    districts: [
                        {
                            district: '仁愛區',
                            lng: 121.7434205,
                            lat: 25.11945421,
                            count: null
                        },
                        {
                            district: '信義區',
                            lng: 121.772646,
                            lat: 25.12576579,
                            count: null
                        },
                        {
                            district: '中正區',
                            lng: 121.7783549,
                            lat: 25.14365754,
                            count: null
                        },
                        {
                            district: '中山區',
                            lng: 121.7308913,
                            lat: 25.14986365,
                            count: null
                        },
                        {
                            district: '安樂區',
                            lng: 121.7078325,
                            lat: 25.14139521,
                            count: null
                        },
                        {
                            district: '暖暖區',
                            lng: 121.7447344,
                            lat: 25.08097003,
                            count: null
                        },
                        {
                            district: '七堵區',
                            lng: 121.683628,
                            lat: 25.10962028,
                            count: null
                        },
                    ]
                },
                {
                    county: '桃園縣',
                    count: null,
                    lat: 24.93759,
                    lng: 121.2168,
                    districts: [
                        {
                            district: '中壢區',
                            lng: 121.2147243,
                            lat: 24.97993803,
                            count: null
                        },
                        {
                            district: '平鎮區',
                            lng: 121.2140051,
                            lat: 24.92117923,
                            count: null
                        },
                        {
                            district: '龍潭區',
                            lng: 121.2117877,
                            lat: 24.85064954,
                            count: null
                        },
                        {
                            district: '楊梅區',
                            lng: 121.1291697,
                            lat: 24.91820989,
                            count: null
                        },
                        {
                            district: '新屋區',
                            lng: 121.067758,
                            lat: 24.97280352,
                            count: null
                        },
                        {
                            district: '觀音區',
                            lng: 121.1155021,
                            lat: 25.02671611,
                            count: null
                        },
                        {
                            district: '桃園區',
                            lng: 121.2996612,
                            lat: 25.00040024,
                            count: null
                        },
                        {
                            district: '龜山區',
                            lng: 121.3569265,
                            lat: 25.02417472,
                            count: null
                        },
                        {
                            district: '八德區',
                            lng: 121.2913102,
                            lat: 24.94968903,
                            count: null
                        },
                        {
                            district: '大溪區',
                            lng: 121.296342,
                            lat: 24.86797026,
                            count: null
                        },
                        {
                            district: '復興區',
                            lng: 121.3754588,
                            lat: 24.72949884,
                            count: null
                        },
                        {
                            district: '大園區',
                            lng: 121.21177,
                            lat: 25.06384709,
                            count: null
                        },
                        {
                            district: '蘆竹區',
                            lng: 121.2831266,
                            lat: 25.06073337,
                            count: null
                        },
                    ]
                },
                {
                    county: '宜蘭縣',
                    count: null,
                    lat: 24.69295,
                    lng: 121.7195,
                    districts:[
                        {
                            district: '宜蘭市',
                            lng: 121.7569358,
                            lat: 24.75021184,
                            count: null
                        },
                        {
                            district: '頭城鎮',
                            lng: 121.845797,
                            lat: 24.90075882,
                            count: null
                        },
                        {
                            district: '礁溪鄉',
                            lng: 121.7346606,
                            lat: 24.81144192,
                            count: null
                        },
                        {
                            district: '壯圍鄉',
                            lng: 121.8017622,
                            lat: 24.75183042,
                            count: null
                        },
                        {
                            district: '員山鄉',
                            lng: 121.6612282,
                            lat: 24.74199237,
                            count: null
                        },
                        {
                            district: '羅東鎮',
                            lng: 121.7701782,
                            lat: 24.67884824,
                            count: null
                        },
                        {
                            district: '三星鄉',
                            lng: 121.6642714,
                            lat: 24.66771972,
                            count: null
                        },
                        {
                            district: '大同鄉',
                            lng: 121.5040369,
                            lat: 24.55152082,
                            count: null
                        },
                        {
                            district: '五結鄉',
                            lng: 121.8058342,
                            lat: 24.68887343,
                            count: null
                        },
                        {
                            district: '冬山鄉',
                            lng: 121.760255,
                            lat: 24.64214986,
                            count: null
                        },
                        {
                            district: '蘇澳鎮',
                            lng: 121.8346892,
                            lat: 24.55467058,
                            count: null
                        },
                        {
                            district: '南澳鄉',
                            lng: 121.6560593,
                            lat: 24.44864058,
                            count: null
                        },
                        {
                            district: '釣魚臺列嶼',
                            lng: 123.475482,
                            lat: 25.746396,
                            count: null
                        },
                    ]
                },
                {
                    county: '高雄市',
                    count: null,
                    lat: 23.01087,
                    lng: 120.666,
                    districts: [
                        {
                            district: '新興區',
                            lng: 120.3067337,
                            lat: 22.62992906,
                            count: null
                        },
                        {
                            district: '前金區',
                            lng: 120.2944217,
                            lat: 22.6269905,        
                            count: null
                        },
                        {
                            district: '苓雅區',
                            lng: 120.3209103,
                            lat: 22.62359448,
                            count: null
                        },
                        {
                            district: '鹽埕區',
                            lng: 120.2842331,
                            lat: 22.62424585,
                            count: null
                        },
                        {
                            district: '鼓山區',
                            lng: 120.274163,
                            lat: 22.65019525,
                            count: null
                        },
                        {
                            district: '旗津區',
                            lng: 120.2891539,
                            lat: 22.58565583,
                            count: null
                        },
                        {
                            district: '前鎮區',
                            lng: 120.3146749,
                            lat: 22.59269724,
                            count: null
                        },
                        {
                            district: '三民區',
                            lng: 120.3179187,
                            lat: 22.64989883,
                            count: null
                        },
                        {
                            district: '楠梓區',
                            lng: 120.300758,
                            lat: 22.72109961,
                            count: null
                        },
                        {
                            district: '小港區',
                            lng: 120.3592605,
                            lat: 22.55140207,
                            count: null
                        },
                        {
                            district: '左營區',
                            lng: 120.2951588,
                            lat: 22.68395699,
                            count: null
                        },
                        {
                            district: '仁武區',
                            lng: 120.3605265,
                            lat: 22.70120782,
                            count: null
                        },
                        {
                            district: '大社區',
                            lng: 120.3707994,
                            lat: 22.73983479,
                            count: null
                        },
                        {
                            district: '岡山區',
                            lng: 120.2978906,
                            lat: 22.80505886,
                            count: null
                        },
                        {
                            district: '路竹區',
                            lng: 120.2659871,
                            lat: 22.85724171,
                            count: null
                        },
                        {
                            district: '阿蓮區',
                            lng: 120.3210967,
                            lat: 22.87022883,
                            count: null
                        },
                        {
                            district: '田寮區',
                            lng: 120.3959842,
                            lat: 22.86394307,
                            count: null
                        },
                        {
                            district: '燕巢區',
                            lng: 120.370799,
                            lat: 22.78769626,
                            count: null
                        },
                        {
                            district: '橋頭區',
                            lng: 120.3006534,
                            lat: 22.75252398,
                            count: null
                        },
                        {
                            district: '梓官區',
                            lng: 120.2593989,
                            lat: 22.748209,
                            count: null
                        },
                        {
                            district: '彌陀區',
                            lng: 120.2394571,
                            lat: 22.77944528,
                            count: null
                        },
                        {
                            district: '永安區',
                            lng: 120.228051,
                            lat: 22.82224585,
                            count: null
                        },
                        {
                            district: '湖內區',
                            lng: 120.2259375,
                            lat: 22.89324952,
                            count: null
                        },
                        {
                            district: '鳳山區',
                            lng: 120.3554359,
                            lat: 22.61379251,
                            count: null
                        },
                        {
                            district: '大寮區',
                            lng: 120.4111468,
                            lat: 22.59283576,
                            count: null
                        },
                        {
                            district: '林園區',
                            lng: 120.399052,
                            lat: 22.50813743,
                            count: null
                        },
                        {
                            district: '鳥松區',
                            lng: 120.3727783,
                            lat: 22.66249302,
                            count: null
                        },
                        {
                            district: '大樹區',
                            lng: 120.425407,
                            lat: 22.71100364,
                            count: null
                        },
                        {
                            district: '旗山區',
                            lng: 120.4754554,
                            lat: 22.86497033,
                            count: null
                        },
                        {
                            district: '美濃區',
                            lng: 120.5634635,
                            lat: 22.90005529,
                            count: null
                        },
                        {
                            district: '六龜區',
                            lng: 120.6585635,
                            lat: 23.01195426,
                            count: null
                        },
                        {
                            district: '內門區',
                            lng: 120.4719272,
                            lat: 22.95668817,
                            count: null
                        },
                        {
                            district: '杉林區',
                            lng: 120.5621971,
                            lat: 22.99694681,
                            count: null
                        },
                        {
                            district: '甲仙區',
                            lng: 120.6232895,
                            lat: 23.11654995,
                            count: null
                        },
                        {
                            district: '桃源區',
                            lng: 120.8523383,
                            lat: 23.2249459,        
                            count: null
                        },
                        {
                            district: '那瑪夏區',
                            lng: 120.741944,
                            lat: 23.275008,       
                            count: null
                        },
                        {
                            district: '茂林區',
                            lng: 120.752384,
                            lat: 22.91993256,
                            count: null
                        },
                        {
                            district: '茄萣區',
                            lng: 120.1980519,
                            lat: 22.88241399,
                            count: null
                        },
                    ]
                },
                {
                    county: '台中市',
                    count: null,
                    lat: 24.23321,
                    lng: 120.9417,
                    districts:[
                        {
                            district: '中區',            
                            lng: 120.680598,           
                            lat: 24.14168566,
                            count: null
                        },
                        {
                            district: '東區',           
                            lng: 120.6970865,           
                            lat: 24.13733209,
                            count: null
                        },
                        {
                            district: '南區',            
                            lng: 120.6646178,           
                            lat: 24.12114107,
                            count: null
                        },
                        {
                            district: '西區',
                            lng: 120.6647579,
                            lat: 24.14391082,
                            count: null
                        },
                        {
                            district: '北區',
                            lng: 120.6809521,
                            lat: 24.15863985,
                            count: null
                        },
                        {
                            district: '北屯區',
                            lng: 120.7362319,
                            lat: 24.18400298,
                            count: null
                        },
                        {
                            district: '西屯區',
                            lng: 120.6270131,
                            lat: 24.18308895,
                            count: null
                        },
                        {
                            district: '南屯區',
                            lng: 120.6177379,
                            lat: 24.14165524,
                            count: null
                        },
                        {
                            district: '太平區',
                            lng: 120.7734217,
                            lat: 24.11477375,
                            count: null
                        },
                        {
                            district: '大里區',
                            lng: 120.6926261,
                            lat: 24.09575742,
                            count: null
                        },
                        {
                            district: '霧峰區',
                            lng: 120.7201989,
                            lat: 24.04332785,
                            count: null
                        },
                        {
                            district: '烏日區',
                            lng: 120.6293305,
                            lat: 24.0839271,
                            count: null
                        },
                        {
                            district: '豐原區',
                            lng: 120.7375715,
                            lat: 24.24990298,
                            count: null
                        },
                        {
                            district: '后里區',
                            lng: 120.7146127,
                            lat: 24.30962483,
                            count: null
                        },
                        {
                            district: '石岡區',
                            lng: 120.7903822,
                            lat: 24.26493299,
                            count: null
                        },
                        {
                            district: '東勢區',
                            lng: 120.8401401,
                            lat: 24.24952637,
                            count: null
                        },
                        {
                            district: '和平區',
                            lng: 121.140185,
                            lat: 24.27620277,
                            count: null
                        },
                        {
                            district: '新社區',
                            lng: 120.8313228,
                            lat: 24.17769289,
                            count: null
                        },
                        {
                            district: '潭子區',
                            lng: 120.710997,
                            lat: 24.21171121,
                            count: null
                        },
                        {
                            district: '大雅區',
                            lng: 120.6411818,
                            lat: 24.22704181,
                            count: null
                        },
                        {
                            district: '神岡區',
                            lng: 120.6733321,
                            lat: 24.26568008,
                            count: null
                        },
                        {
                            district: '大肚區',
                            lng: 120.5543243,
                            lat: 24.14467504,
                            count: null
                        },
                        {
                            district: '沙鹿區',
                            lng: 120.5838628,
                            lat: 24.23425212,
                            count: null
                        },
                        {
                            district: '龍井區',
                            lng: 120.5283728,
                            lat: 24.20062892,
                            count: null
                        },
                        {
                            district: '梧棲區',
                            lng: 120.5301259,
                            lat: 24.24552431,
                            count: null
                        },
                        {
                            district: '清水區',
                            lng: 120.5809094,
                            lat: 24.29205743,
                            count: null
                        },
                        {
                            district: '大甲區',
                            lng: 120.6357901,
                            lat: 24.37827161,
                            count: null
                        },
                        {
                            district: '外埔區',
                            lng: 120.6650639,
                            lat: 24.33551071,
                            count: null
                        },
                        {
                            district: '大安區',
                            lng: 120.5914407,
                            lat: 24.36509555,
                            count: null
                        },
                    ]
                },
                {
                    county: '台南市',
                    count: null,
                    lat: 23.1417,
                    lng: 120.2513,
                    districts: [
                        {
                            district: '中西區',
                            lng: 120.192874,
                            lat: 22.99594458,
                            count: null
                        },
                        {
                            district: '東區',            
                            lng: 120.2281858,
                            lat: 22.98178202,
                            count: null
                        },
                        {
                            district: '南區',
                            lng: 120.1903743,
                            lat: 22.95561863,
                            count: null
                        },
                        {
                            district: '北區',
                            lng: 120.2068735,
                            lat: 23.01012179,
                            count: null
                        },
                        {
                            district: '安平區',
                            lng: 120.1649949,
                            lat: 22.99008437,
                            count: null
                        },
                        {
                            district: '安南區',
                            lng: 120.1526189,
                            lat: 23.04869681,
                            count: null
                        },
                        {
                            district: '永康區',
                            lng: 120.2542795,
                            lat: 23.02729532,
                            count: null
                        },
                        {
                            district: '歸仁區',
                            lng: 120.2930627,
                            lat: 22.94679469,
                            count: null
                        },
                        {
                            district: '新化區',
                            lng: 120.3357964,
                            lat: 23.03394545,
                            count: null
                        },
                        {
                            district: '左鎮區',
                            lng: 120.4123917,
                            lat: 23.02604611,
                            count: null
                        },
                        {
                            district: '玉井區',
                            lng: 120.4609622,
                            lat: 23.11480926,
                            count: null
                        },
                        {
                            district: '楠西區',
                            lng: 120.5170304,
                            lat: 23.17885854,
                            count: null
                        },
                        {
                            district: '南化區',
                            lng: 120.5441223,
                            lat: 23.1151111,
                            count: null
                        },
                        {
                            district: '仁德區',
                            lng: 120.2418788,
                            lat: 22.94130931,
                            count: null
                        },
                        {
                            district: '關廟區',
                            lng: 120.3342821,
                            lat: 22.95577909,
                            count: null
                        },
                        {
                            district: '龍崎區',
                            lng: 120.3869373,
                            lat: 22.95482276,
                            count: null
                        },
                        {
                            district: '官田區',
                            lng: 120.3479918,
                            lat: 23.19098548,
                            count: null
                        },
                        {
                            district: '麻豆區',
                            lng: 120.241308,
                            lat: 23.18248033,
                            count: null
                        },
                        {
                            district: '佳里區',
                            lng: 120.178593,
                            lat: 23.1669941,
                            count: null
                        },
                        {
                            district: '西港區',
                            lng: 120.2002309,
                            lat: 23.12491893,
                            count: null
                        },
                        {
                            district: '七股區',
                            lng: 120.1005854,
                            lat: 23.12326578,
                            count: null
                        },
                        {
                            district: '將軍區',
                            lng: 120.1276958,
                            lat: 23.20834413,
                            count: null
                        },
                        {
                            district: '學甲區',
                            lng: 120.1841865,
                            lat: 23.25219805,
                            count: null
                        },
                        {
                            district: '北門區',
                            lng: 120.1262357,
                            lat: 23.2777708,
                            count: null
                        },
                        {
                            district: '新營區',
                            lng: 120.2954067,
                            lat: 23.30152488,
                            count: null
                        },
                        {
                            district: '後壁區',
                            lng: 120.3485081,
                            lat: 23.36201478,
                            count: null
                        },
                        {
                            district: '白河區',
                            lng: 120.4578565,
                            lat: 23.35132068,
                            count: null
                        },
                        {
                            district: '東山區',
                            lng: 120.4441211,
                            lat: 23.2783187,
                            count: null
                        },
                        {
                            district: '六甲區',
                            lng: 120.3800259,
                            lat: 23.2272672,
                            count: null
                        },
                        {
                            district: '下營區',
                            lng: 120.26484,
                            lat: 23.23103978,
                            count: null
                        },
                        {
                            district: '柳營區',
                            lng: 120.3549205,
                            lat: 23.26887001,
                            count: null
                        },
                        {
                            district: '鹽水區',
                            lng: 120.2482977,
                            lat: 23.29798622,
                            count: null
                        },
                        {
                            district: '善化區',
                            lng: 120.2988274,
                            lat: 23.14031072,
                            count: null
                        },
                        {
                            district: '大內區',
                            lng: 120.3988147,
                            lat: 23.14482152,
                            count: null
                        },
                        {
                            district: '山上區',
                            lng: 120.370977,
                            lat: 23.09689329,
                            count: null
                        },
                        {
                            district: '新市區',
                            lng: 120.2923941,
                            lat: 23.08319496,
                            count: null
                        },
                        {
                            district: '安定區',
                            lng: 120.2296235,
                            lat: 23.09974927,
                            count: null
                        },
                    ]
                },
                {
                    county: '彰化縣',
                    count: null,
                    lat: 23.99297,
                    lng: 120.4818,
                    districts: [
                        {
                            district: '彰化市',
                            lng: 120.5694208,
                            lat: 24.07532909,
                            count: null
                        },
                        {
                            district: '芬園鄉',
                            lng: 120.6294414,
                            lat: 24.00628794,
                            count: null
                        },
                        {
                            district: '花壇鄉',
                            lng: 120.5597655,
                            lat: 24.03006875,
                            count: null
                        },
                        {
                            district: '秀水鄉',
                            lng: 120.5041184,
                            lat: 24.03249405,
                            count: null
                        },
                        {
                            district: '鹿港鎮',
                            lng: 120.4385491,
                            lat: 24.08286685,
                            count: null
                        },
                        {
                            district: '福興鄉',
                            lng: 120.4310511,
                            lat: 24.03021674,
                            count: null
                        },
                        {
                            district: '線西鄉',
                            lng: 120.452157,
                            lat: 24.13158127,
                            count: null
                        },
                        {
                            district: '和美鎮',
                            lng: 120.5112045,
                            lat: 24.11379535,
                            count: null
                        },
                        {
                            district: '伸港鄉',
                            lng: 120.486449,
                            lat: 24.16367107,
                            count: null
                        },
                        {
                            district: '員林市',
                            lng: 120.593073,
                            lat: 23.95650448,
                            count: null
                        },
                        {
                            district: '社頭鄉',
                            lng: 120.6021661,
                            lat: 23.90536413,
                            count: null
                        },
                        {
                            district: '永靖鄉',
                            lng: 120.5416032,
                            lat: 23.92139507,
                            count: null
                        },
                        {
                            district: '埔心鄉',
                            lng: 120.5342802,
                            lat: 23.95277521,
                            count: null
                        },
                        {
                            district: '溪湖鎮',
                            lng: 120.4831739,
                            lat: 23.95171456,
                            count: null
                        },
                        {
                            district: '大村鄉',
                            lng: 120.5586866,
                            lat: 23.99209206,
                            count: null
                        },
                        {
                            district: '埔鹽鄉',
                            lng: 120.4594626,
                            lat: 23.99204417,
                            count: null
                        },
                        {
                            district: '田中鎮',
                            lng: 120.5903471,
                            lat: 23.85723872,
                            count: null
                        },
                        {
                            district: '北斗鎮',
                            lng: 120.5331566,
                            lat: 23.867574,
                            count: null
                        },
                        {
                            district: '田尾鄉',
                            lng: 120.5223244,
                            lat: 23.90056065,
                            count: null
                        },
                        {
                            district: '埤頭鄉',
                            lng: 120.4675642,
                            lat: 23.88234118,
                            count: null
                        },
                        {
                            district: '溪州鄉',
                            lng: 120.5224904,
                            lat: 23.82725185,
                            count: null
                        },
                        {
                            district: '竹塘鄉',
                            lng: 120.4136645,
                            lat: 23.8505872,
                            count: null
                        },
                        {
                            district: '二林鎮',
                            lng: 120.404225,
                            lat: 23.91621405,
                            count: null
                        },
                        {
                            district: '大城鄉',
                            lng: 120.3113284,
                            lat: 23.85069276,
                            count: null
                        },
                        {
                            district: '芳苑鄉',
                            lng: 120.3539226,
                            lat: 23.9537906,
                            count: null
                        },
                        {
                            district: '二水鄉',
                            lng: 120.628589,
                            lat: 23.8092402,
                            count: null
                        },
                    ]
                },
                {
                    county: '屏東縣',
                    count: null,
                    lat: 22.54951,
                    lng: 120.62,
                    districts: [
                        {
                            district: '屏東市',
                            lng: 120.4799948,
                            lat: 22.6647375,
                            count: null
                        },
                        {
                            district: '三地門鄉',
                            lng: 120.6865219,
                            lat: 22.79786847,
                            count: null
                        },
                        {
                            district: '霧臺鄉',
                            lng: 120.8008099,
                            lat: 22.75990478,
                            count: null
                        },
                        {
                            district: '瑪家鄉',
                            lng: 120.6799239,
                            lat: 22.67107764,
                            count: null
                        },
                        {
                            district: '九如鄉',
                            lng: 120.4845044,
                            lat: 22.7316677,
                            count: null
                        },
                        {
                            district: '里港鄉',
                            lng: 120.5061276,
                            lat: 22.79854831,
                            count: null
                        },
                        {
                            district: '高樹鄉',
                            lng: 120.6017678,
                            lat: 22.80992022,
                            count: null
                        },
                        {
                            district: '鹽埔鄉',
                            lng: 120.5693941,
                            lat: 22.74253636,
                            count: null
                        },
                        {
                            district: '長治鄉',
                            lng: 120.555979,
                            lat: 22.69454952,
                            count: null
                        },
                        {
                            district: '麟洛鄉',
                            lng: 120.5299693,
                            lat: 22.64876367,
                            count: null
                        },
                        {
                            district: '竹田鄉',
                            lng: 120.5266379,
                            lat: 22.58855636,
                            count: null
                        },
                        {
                            district: '內埔鄉',
                            lng: 120.5888222,
                            lat: 22.65116933,
                            count: null
                        },
                        {
                            district: '萬丹鄉',
                            lng: 120.4766188,
                            lat: 22.58849547,
                            count: null
                        },
                        {
                            district: '潮州鎮',
                            lng: 120.5568063,
                            lat: 22.53642947,
                            count: null
                        },
                        {
                            district: '泰武鄉',
                            lng: 120.6917929,
                            lat: 22.60408477,
                            count: null
                        },
                        {
                            district: '來義鄉',
                            lng: 120.6857232,
                            lat: 22.50157206,
                            count: null
                        },
                        {
                            district: '萬巒鄉',
                            lng: 120.601817,
                            lat: 22.58233459,
                            count: null
                        },
                        {
                            district: '崁頂鄉',
                            lng: 120.5006598,
                            lat: 22.51528151,
                            count: null
                        },
                        {
                            district: '新埤鄉',
                            lng: 120.5846257,
                            lat: 22.48676279,
                            count: null
                        },
                        {
                            district: '南州鄉',
                            lng: 120.5180561,
                            lat: 22.47980704,
                            count: null
                        },
                        {
                            district: '林邊鄉',
                            lng: 120.5125095,
                            lat: 22.44142101,
                            count: null
                        },
                        {
                            district: '東港鎮',
                            lng: 120.4751333,
                            lat: 22.46265635,
                            count: null
                        },
                        {
                            district: '琉球鄉',
                            lng: 120.3710466,
                            lat: 22.34000278,
                            count: null
                        },
                        {
                            district: '佳冬鄉',
                            lng: 120.5476124,
                            lat: 22.42980624,
                            count: null
                        },
                        {
                            district: '新園鄉',
                            lng: 120.4501429,
                            lat: 22.5171903,
                            count: null
                        },
                        {
                            district: '枋寮鄉',
                            lng: 120.5975845,
                            lat: 22.40334199,
                            count: null
                        },
                        {
                            district: '枋山鄉',
                            lng: 120.6567673,
                            lat: 22.27086962,
                            count: null
                        },
                        {
                            district: '春日鄉',
                            lng: 120.6975799,
                            lat: 22.40399754,
                            count: null
                        },
                        {
                            district: '獅子鄉',
                            lng: 120.7356454,
                            lat: 22.26084921,
                            count: null
                        },
                        {
                            district: '車城鄉',
                            lng: 120.7432633,
                            lat: 22.07915617,
                            count: null
                        },
                        {
                            district: '牡丹鄉',
                            lng: 120.8173609,
                            lat: 22.15552859,
                            count: null
                        },
                        {
                            district: '恆春鎮',
                            lng: 120.7632537,
                            lat: 21.98531645,
                            count: null
                        },
                        {
                            district: '滿州鄉',
                            lng: 120.8435675,
                            lat: 22.04930015,
                            count: null
                        },
                    ]
                },
                {
                    county: '雲林縣',
                    count: null,
                    lat: 23.75585,
                    lng: 120.3897,
                    districts: [
                        {
                            district: '斗南鎮',
                            lng: 120.4826356,
                            lat: 23.67066393,
                            count: null
                        },
                        {
                            district: '大埤鄉',
                            lng: 120.4255592,
                            lat: 23.6455971,
                            count: null
                        },
                        {
                            district: '虎尾鎮',
                            lng: 120.4293061,
                            lat: 23.71661545,
                            count: null
                        },
                        {
                            district: '土庫鎮',
                            lng: 120.3647252,
                            lat: 23.69110665,
                            count: null
                        },
                        {
                            district: '褒忠鄉',
                            lng: 120.3116122,
                            lat: 23.71613204,
                            count: null
                        },
                        {
                            district: '東勢鄉',
                            lng: 120.2564173,
                            lat: 23.69612324,
                            count: null
                        },
                        {
                            district: '臺西鄉',
                            lng: 120.2054952,
                            lat: 23.71600815,
                            count: null
                        },
                        {
                            district: '崙背鄉',
                            lng: 120.3339769,
                            lat: 23.77849791,
                            count: null
                        },
                        {
                            district: '麥寮鄉',
                            lng: 120.243533,
                            lat: 23.78817056,
                            count: null
                        },
                        {
                            district: '斗六市',
                            lng: 120.5600044,
                            lat: 23.70651883,
                            count: null
                        },
                        {
                            district: '林內鄉',
                            lng: 120.6155018,
                            lat: 23.7557209,
                            count: null
                        },
                        {
                            district: '古坑鄉',
                            lng: 120.6117351,
                            lat: 23.62545469,
                            count: null
                        },
                        {
                            district: '莿桐鄉',
                            lng: 120.5290419,
                            lat: 23.76973894,
                            count: null
                        },
                        {
                            district: '西螺鎮',
                            lng: 120.4580795,
                            lat: 23.77942109,
                            count: null
                        },
                        {
                            district: '二崙鄉',
                            lng: 120.3964598,
                            lat: 23.7925521,
                            count: null
                        },
                        {
                            district: '北港鎮',
                            lng: 120.2940164,
                            lat: 23.59219528,
                            count: null
                        },
                        {
                            district: '水林鄉',
                            lng: 120.2352734,
                            lat: 23.56162849,
                            count: null
                        },
                        {
                            district: '口湖鄉',
                            lng: 120.1413711,
                            lat: 23.55365395,
                            count: null
                        },
                        {
                            district: '四湖鄉',
                            lng: 120.2064699,
                            lat: 23.64206875,
                            count: null
                        },
                        {
                            district: '元長鄉',
                            lng: 120.3279617,
                            lat: 23.64243095,
                            count: null
                        },
                    ]
                },
                {
                    county: '苗栗縣',
                    count: null,
                    lat: 24.48927,
                    lng: 120.9417,
                    districts: [
                        {
                            district: '竹南鎮',
                            lng: 120.8777316,
                            lat: 24.69862459,
                            count: null
                        },
                        {
                            district: '頭份市',
                            lng: 120.9189437,
                            lat: 24.67628243,
                            count: null
                        },
                        {
                            district: '三灣鄉',
                            lng: 120.9525745,
                            lat: 24.63599405,
                            count: null
                        },
                        {
                            district: '南庄鄉',
                            lng: 121.017471,
                            lat: 24.56608432,
                            count: null
                        },
                        {
                            district: '獅潭鄉',
                            lng: 120.9206688,
                            lat: 24.51978614,
                            count: null
                        },
                        {
                            district: '後龍鎮',
                            lng: 120.781205,
                            lat: 24.6156265,
                            count: null
                        },
                        {
                            district: '通霄鎮',
                            lng: 120.7146378,
                            lat: 24.4850464,
                            count: null
                        },
                        {
                            district: '苑裡鎮',
                            lng: 120.6882195,
                            lat: 24.4110232,
                            count: null
                        },
                        {
                            district: '苗栗市',
                            lng: 120.8112299,
                            lat: 24.56382141,
                            count: null
                        },
                        {
                            district: '造橋鄉',
                            lng: 120.8695663,
                            lat: 24.62481314,
                            count: null
                        },
                        {
                            district: '頭屋鄉',
                            lng: 120.8826631,
                            lat: 24.57345497,
                            count: null
                        },
                        {
                            district: '公館鄉',
                            lng: 120.8505904,
                            lat: 24.50249686,
                            count: null
                        },
                        {
                            district: '大湖鄉',
                            lng: 120.8631192,
                            lat: 24.39359641,
                            count: null
                        },
                        {
                            district: '泰安鄉',
                            lng: 121.0681571,
                            lat: 24.41925819,
                            count: null
                        },
                        {
                            district: '銅鑼鄉',
                            lng: 120.7992043,
                            lat: 24.45591832,
                            count: null
                        },
                        {
                            district: '三義鄉',
                            lng: 120.7701929,
                            lat: 24.38081659,
                            count: null
                        },
                        {
                            district: '西湖鄉',
                            lng: 120.7614144,
                            lat: 24.54153218,
                            count: null
                        },
                        {
                            district: '卓蘭鎮',
                            lng: 120.8561966,
                            lat: 24.32510167,
                            count: null
                        },
                    ]
                },
                {
                    county: '嘉義縣',
                    count: null,
                    lat: 23.45889,
                    lng: 120.574,
                    districts: [
                        {
                            district: '番路鄉',
                            lng: 120.6075335,
                            lat: 23.42765669,
                            count: null
                        },
                        {
                            district: '梅山鄉',
                            lng: 120.6387459,
                            lat: 23.55535465,
                            count: null
                        },
                        {
                            district: '竹崎鄉',
                            lng: 120.5965771,
                            lat: 23.50376527,
                            count: null
                        },
                        {
                            district: '阿里山鄉',
                            lng: 120.7596173,
                            lat: 23.44077619,
                            count: null
                        },
                        {
                            district: '中埔鄉',
                            lng: 120.5365312,
                            lat: 23.40408998,
                            count: null
                        },
                        {
                            district: '大埔鄉',
                            lng: 120.5896466,
                            lat: 23.28848426,
                            count: null
                        },
                        {
                            district: '水上鄉',
                            lng: 120.4147357,
                            lat: 23.42911287,
                            count: null
                        },
                        {
                            district: '鹿草鄉',
                            lng: 120.3045468,
                            lat: 23.40811736,
                            count: null
                        },
                        {
                            district: '太保市',
                            lng: 120.3440009,
                            lat: 23.4729191,
                            count: null
                        },
                        {
                            district: '朴子市',
                            lng: 120.2538977,
                            lat: 23.44610605,
                            count: null
                        },
                        {
                            district: '東石鄉',
                            lng: 120.1738682,
                            lat: 23.46866059,
                            count: null
                        },
                        {
                            district: '六腳鄉',
                            lng: 120.2714728,
                            lat: 23.51020984,
                            count: null
                        },
                        {
                            district: '新港鄉',
                            lng: 120.3482873,
                            lat: 23.54581295,
                            count: null
                        },
                        {
                            district: '民雄鄉',
                            lng: 120.4442798,
                            lat: 23.54255347,
                            count: null
                        },
                        {
                            district: '大林鎮',
                            lng: 120.4807865,
                            lat: 23.59890827,
                            count: null
                        },
                        {
                            district: '溪口鄉',
                            lng: 120.4010282,
                            lat: 23.59353089,
                            count: null
                        },
                        {
                            district: '義竹鄉',
                            lng: 120.2239433,
                            lat: 23.34575872,
                            count: null
                        },
                        {
                            district: '布袋鎮',
                            lng: 120.1777498,
                            lat: 23.37494276,
                            count: null
                        },
                    ]
                },
                {
                    county: '新竹縣',
                    count: null,
                    lat: 24.70328,
                    lng: 121.1252,
                    districts: [
                        {
                            district: '竹北市',
                            lng: 120.9948704,
                            lat: 24.83816209,
                            count: null
                        },
                        {
                            district: '湖口鄉',
                            lng: 121.0517242,
                            lat: 24.88566341,
                            count: null
                        },
                        {
                            district: '新豐鄉',
                            lng: 120.9956033,
                            lat: 24.90731298,
                            count: null
                        },
                        {
                            district: '新埔鎮',
                            lng: 121.0939886,
                            lat: 24.84133959,
                            count: null
                        },
                        {
                            district: '關西鎮',
                            lng: 121.1866221,
                            lat: 24.78514681,
                            count: null
                        },
                        {
                            district: '芎林鄉',
                            lng: 121.1046394,
                            lat: 24.7657116,
                            count: null
                        },
                    ]
                },
                {
                    county: '新竹市',
                    count: null,
                    lat: 24.80395,
                    lng: 120.9647,
                    districts:[
                        {
                            district: '北區',
                            lng: 120.9491233,
                            lat: 24.82269542,
                            count: null
                        },
                        {
                            district: '東區',
                            lng: 120.9927505,
                            lat: 24.79028174,
                            count: null
                        },
                        {
                            district: '香山區',
                            lng: 120.9236727,
                            lat: 24.77104342,
                            count: null
                        },
                    ]
                },
                {
                    county: '南投縣',
                    count: null,
                    lat: 23.83876,
                    lng: 120.9876,
                    districts: [
                        {
                            district: '南投市',
                            lng: 120.6787658,
                            lat: 23.92173537,
                            count: null
                        },
                        {
                            district: '中寮鄉',
                            lng: 120.7859159,
                            lat: 23.90589214,
                            count: null
                        },
                        {
                            district: '草屯鎮',
                            lng: 120.7326182,
                            lat: 23.98321081,
                            count: null
                        },
                        {
                            district: '國姓鄉',
                            lng: 120.8676052,
                            lat: 24.03135413,
                            count: null
                        },
                        {
                            district: '埔里鎮',
                            lng: 120.9625259,
                            lat: 23.97892591,
                            count: null
                        },
                        {
                            district: '仁愛鄉',
                            lng: 121.1443879,
                            lat: 24.02886513,
                            count: null
                        },
                        {
                            district: '名間鄉',
                            lng: 120.6774402,
                            lat: 23.8510771,
                            count: null
                        },
                        {
                            district: '集集鎮',
                            lng: 120.7854192,
                            lat: 23.83701687,
                            count: null
                        },
                        {
                            district: '水里鄉',
                            lng: 120.8622721,
                            lat: 23.79612907,
                            count: null
                        },
                        {
                            district: '魚池鄉',
                            lng: 120.9256736,
                            lat: 23.87601213,
                            count: null
                        },
                        {
                            district: '信義鄉',
                            lng: 121.0212867,
                            lat: 23.6554647,
                            count: null
                        },
                        {
                            district: '竹山鎮',
                            lng: 120.7100797,
                            lat: 23.69805518,
                            count: null
                        },
                        {
                            district: '鹿谷鄉',
                            lng: 120.7815065,
                            lat: 23.73776029,
                            count: null
                        },
                    ]
                },
                {
                    county: '嘉義市',
                    count: null,
                    lat: 23.47545,
                    lng: 120.4473,
                    districts: [
                        {
                            district: '西區',
                            lng: 120.4248724,
                            lat: 23.47915529,
                            count: null
                        },
                        {
                            district: '東區',
                            lng: 120.4706244,
                            lat: 23.48170334,
                            count: null
                        },
                    ]
                },
                {
                    county: '台東縣',
                    count: null,
                    lat: 22.98461,
                    lng: 120.9876,
                    districts: [
                        {
                            district: '臺東市',
                            lng: 121.1103647,
                            lat: 22.75165721,
                            count: null
                        },
                        {
                            district: '綠島鄉',
                            lng: 121.4901951,
                            lat: 22.66017537,
                            count: null
                        },
                        {
                            district: '蘭嶼鄉',
                            lng: 121.5508328,
                            lat: 22.04616835,
                            count: null
                        },
                        {
                            district: '延平鄉',
                            lng: 120.9831902,
                            lat: 22.90343174,
                            count: null
                        },
                        {
                            district: '卑南鄉',
                            lng: 121.0015521,
                            lat: 22.76494453,
                            count: null
                        },
                        {
                            district: '鹿野鄉',
                            lng: 121.1560376,
                            lat: 22.95125666,
                            count: null
                        },
                        {
                            district: '關山鎮',
                            lng: 121.1766197,
                            lat: 23.03780684,
                            count: null
                        },
                        {
                            district: '海端鄉',
                            lng: 121.0175672,
                            lat: 23.11478528,
                            count: null
                        },
                        {
                            district: '池上鄉',
                            lng: 121.2184501,
                            lat: 23.09248714,
                            count: null
                        },
                        {
                            district: '東河鄉',
                            lng: 121.2517917,
                            lat: 22.98006921,
                            count: null
                        },
                        {
                            district: '成功鎮',
                            lng: 121.3537983,
                            lat: 23.12663716,
                            count: null
                        },
                        {
                            district: '長濱鄉',
                            lng: 121.4261725,
                            lat: 23.33476899,
                            count: null
                        },
                        {
                            district: '太麻里鄉',
                            lng: 120.9797643,
                            lat: 22.59098082,
                            count: null
                        },
                        {
                            district: '金峰鄉',
                            lng: 120.8570384,
                            lat: 22.58161687,
                            count: null
                        },
                        {
                            district: '大武鄉',
                            lng: 120.8991703,
                            lat: 22.38359522,
                            count: null
                        },
                        {
                            district: '達仁鄉',
                            lng: 120.8355239,
                            lat: 22.38430718,
                            count: null
                        },
                    ]
                },
                {
                    county: '花蓮縣',
                    count: null,
                    lat: 23.7569,
                    lng: 121.3542,
                    districts: [
                        {
                            district: '花蓮市',
                            lng: 121.6071463,
                            lat: 23.99700271,
                            count: null
                        },
                        {
                            district: '新城鄉',
                            lng: 121.6137969,
                            lat: 24.05579952,
                            count: null
                        },
                        {
                            district: '秀林鄉',
                            lng: 121.4807194,
                            lat: 24.12374414,
                            count: null
                        },
                        {
                            district: '吉安鄉',
                            lng: 121.5646738,
                            lat: 23.95546585,
                            count: null
                        },
                        {
                            district: '壽豐鄉',
                            lng: 121.5341569,
                            lat: 23.84459714,
                            count: null
                        },
                        {
                            district: '鳳林鎮',
                            lng: 121.4698848,
                            lat: 23.74324462,
                            count: null
                        },
                        {
                            district: '光復鄉',
                            lng: 121.4351231,
                            lat: 23.64658742,
                            count: null
                        },
                        {
                            district: '豐濱鄉',
                            lng: 121.4942331,
                            lat: 23.58519428,
                            count: null
                        },
                        {
                            district: '瑞穗鄉',
                            lng: 121.4073472,
                            lat: 23.5156124,
                            count: null
                        },
                        {
                            district: '萬榮鄉',
                            lng: 121.3189531,
                            lat: 23.72772629,
                            count: null
                        },
                        {
                            district: '玉里鎮',
                            lng: 121.3604476,
                            lat: 23.37143588,
                            count: null
                        },
                        {
                            district: '卓溪鄉',
                            lng: 121.1804222,
                            lat: 23.39062875,
                            count: null
                        },
                        {
                            district: '富里鄉',
                            lng: 121.2980494,
                            lat: 23.19672092,
                            count: null
                        },
                    ]
                },
                {
                    county: '金門縣',
                    count: null,
                    lat: 24.43679,
                    lng: 118.3186,
                    districts: [
                        {
                            district: '金沙鎮',
                            lng: 118.40841,
                            lat: 24.45865,
                            count: null
                        },
                        {
                            district: '金湖鎮',
                            lng: 118.40373,
                            lat: 24.41496,
                            count: null
                        },
                        {
                            district: '金寧鄉',
                            lng: 118.31705,
                            lat: 24.42482,
                            count: null
                        },
                        {
                            district: '金城鎮',
                            lng: 118.30128,
                            lat: 24.38402,
                            count: null
                        },
                        {
                            district: '烈嶼鄉',
                            lng: 118.22789,
                            lat: 24.40166,
                            count: null
                        },
                        {
                            district: '烏坵鄉',
                            lng: 119.452738,
                            lat: 24.992338,
                            count: null
                        },
                    ]
                },
                {
                    county: '澎湖縣',
                    count: null,
                    lat: 23.56548,
                    lng: 119.6151,
                    districts: [
                        {
                            district: '馬公市',
                            lng: 119.59234,
                            lat: 23.55534,
                            count: null
                        },
                        {
                            district: '西嶼鄉',
                            lng: 119.50783,
                            lat: 23.59975,
                            count: null
                        },
                        {
                            district: '望安鄉',
                            lng: 119.50406,
                            lat: 23.36904,
                            count: null
                        },
                        {
                            district: '七美鄉',
                            lng: 119.43393,
                            lat: 23.20108,
                            count: null
                        },
                        {
                            district: '白沙鄉',
                            lng: 119.59251,
                            lat: 23.64178,
                            count: null
                        },
                        {
                            district: '湖西鄉',
                            lng: 119.64462,
                            lat: 23.57364,
                            count: null
                        },
                    ]
                },
                {
                    county: '連江縣',
                    count: null,
                    lat: 26.19737,
                    lng: 119.5397,
                    districts: [
                        {
                            district: '南竿鄉',
                            lng: 119.931128,
                            lat: 26.154321,
                            count: null
                        },
                        {
                            district: '北竿鄉',
                            lng: 119.994251,
                            lat: 26.225637,
                            count: null
                        },
                        {
                            district: '莒光鄉',
                            lng: 119.938877,
                            lat: 25.97298,
                            count: null
                        },
                        {
                            district: '東引鄉',
                            lng: 120.4903,
                            lat: 26.366101,
                            count: null
                        },
                    ]
                }
            ]

            this.countyLocation = countyLocationDefault
        },
        translateEmpty: function (val) {
            if(val){
                return '空'
            }else{
                return '租'
            }
        },
    },
    computed:{
        filterByWord: function () {
            return this.houseMgtList.filter((houseItem) => {
                if( this.filterWord ){
                    if( houseItem.houseName.includes(this.filterWord) || houseItem.address.includes(this.filterWord) ){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByCounty: function () {
            return this.filterByWord.filter((houseItem) => {
                if(this.filterQuery.county){
                    if(houseItem.county.includes(this.filterQuery.county) == true){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByDistrict: function () {
            return this.filterByCounty.filter((houseItem) => {
                if( this.filterQuery.district){
                    if(houseItem.district.includes(this.filterQuery.district) == true){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByRent: function () {
            return this.filterByDistrict.filter((houseItem) => {
                if( this.filterQuery.rent ){
                    if( this.filterQuery.rent[1] >= 100000){
                        if( this.filterQuery.rent[0] <= houseItem.rentPrice){
                            return houseItem
                        }
                    }else{
                        if( this.filterQuery.rent[0] <= houseItem.rentPrice && this.filterQuery.rent[1] >= houseItem.rentPrice ){
                            return houseItem
                        }
                    }
                    
                }else{
                    return houseItem
                }
            });
        },
        filterByHouseType: function () {
            return this.filterByRent.filter((houseItem) => {
                if( this.filterQuery.houseType ){
                    if( this.filterQuery.houseType == houseItem.houseType ){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByBuildingType: function () {
            return this.filterByHouseType.filter((houseItem) => {
                if( this.filterQuery.buildingType ){
                    if( this.filterQuery.buildingType == houseItem.buildingType ){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        filterByTask: function () {
            return this.filterByBuildingType.filter((houseItem) => {
                if( this.filterQuery.task ){
                    if( this.filterQuery.task == 0 ){
                        if( houseItem.taskStatus == 0 ){
                            return houseItem
                        }
                    }else if( this.filterQuery.task == 1 ){
                        if( houseItem.taskStatus == 1 ){
                            return houseItem
                        }
                    }
                }else{
                    return houseItem
                }
            });
        },
        getCountyLocation: function () {
            const counties = this.filterByTask
            let emptyObj = {}
            // 計算出每個縣市的房子有幾個
            counties.forEach( county => {
                county = county.county
                emptyObj[county] = emptyObj[county] ? emptyObj[county] + 1 : 1;
            });
            // 因為是用縣當key，所以把key讀取出來重新轉換
            let key = Object.keys(emptyObj)

            // 計算出的數量重新組裝成物件
            for (let i = 0; i < key.length; i++) {
                // 讀出每個縣的房子總數
                const count = emptyObj[key[i]];
                // 讀取預設縣市物件,把房數塞入
                for (let j = 0; j < this.countyLocation.length; j++) {
                    const element = this.countyLocation[j];
                    if(element.county == key[i]){
                        element.count = count
                    }
                }
            }
            return this.countyLocation
        },
        getDistrictLocation: function () {
            const houses = this.filterByTask
            let countyObj = {},
                districtObj = {}
            // console.log(houses)
            this.countyLocation.forEach ( county => {
                if( county.count ){
                    houses.forEach( (district, index) => {
                        if( county.county == district.county){
                            district = district.district
                            districtObj[district] = districtObj[district] ? districtObj[district] + 1 : 1;
                            
                            let districtKey = Object.keys(districtObj)

                            // console.log(districtObj)
                            county.districts.forEach( cdistrict => {
                                // console.log(districtObj[cdistrict.district])
                                // console.log(cdistrict.district)
                                cdistrict.count = districtObj[cdistrict.district]
                                // console.log(cdistrict)
                            })
                        }
                    });
                }
                districtObj = {}
            })
            return this.countyLocation
        },
        // getHouseCenter: function () {
        //     console.log(this.houseMarkerCenter.lat)
        //     console.log(this.houseMarkerCenter.lng)
        //     if(this.houseMarkerCenter){
        //         this.setCenter(this.houseMarkerCenter.lat, this.houseMarkerCenter.lng)
        //     }
        //     return this.houseMarkerCenter
        // },
        ...mapGetters({
            houseMgtList: 'GET_HOUSE_MGT_LIST',
            filterQuery: 'GET_HOUSE_MGT_FILTER_QUERY',
            filterWord: 'GET_HOUSE_MGT_FILTER_WORD',
            houseMarkerCenter: 'GET_HOUSE_MGT_MARKER_CENTER',
        }),
    },
}
</script>
<style lang="scss">
    #map-content{
        width: 100%;
        height: 100%;
        div{
            outline: none !important;
        }
        .firstHeading{
                margin: 0;
                font-size: 14px;
                font-weight: 500;
                height: 36px;
                display: flex;
                align-items: center;
        }
        .gm-style .gm-style-iw-c{
            padding: 0;
        }
        .gm-style .gm-style-iw-t::after{
           display: none;
        }
        .gm-ui-hover-effect{
            display: none !important;
        }
        .gm-style-iw {
            background-color: #fff;
            border: 1px solid rgba(72, 181, 233, 0.6);
            border-radius: 10px;
            color: #000 !important;
            text-align: center;
            top: -4px !important;
            width: 113px !important;
            .gm-style-iw-d{
                display: flex;
                justify-content: center;
                align-items: center;
                overflow: unset !important;
                max-height: none !important;
            }
        }
        
        #cluster{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            border: solid 4px #ffffff;
            background: #ff9275;
            border-radius: 100px;
            color: #ffffff;
            width: 92px;
            height: 92px;
            span{
                display: block;
                font-size: 14px;
            }
            span:first-child{
                font-size: 20px;
                margin-bottom: 2px;
                font-weight: 500;
            }
        }
        #cluster:hover{
            border: solid 4px #f5a623;
            background: #fff !important;
            color: #f5a623;
        }
        .cluster-item{
            border: solid 2px #ffffff;
            background: #ff9275;
            border-radius: 100px;
            width: 12px;
            height: 12px;
        }
        .custom-clustericon{
            display: flex;
            align-items: center;
            justify-content: center;
            border: solid 2px #ffffff;
            background: #ff9275;
            border-radius: 100px;
            color: #ffffff;
        }
        .custom-clustericon:hover{
            border: solid 2px #f5a623;
            background: #fff !important;
            color: #f5a623;
        }
        .custom-clustericon-1{
            border: solid 2px #ffffff;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/landlordMapSearch/MapContent.vue